<template>
    <div class="trading-desk-container wine-details">
        <v-layout column wrap fill-height>
            <div class="collections-container" v-if="isLogged">
                <div class="collections-wrapper" v-if="wineInfo.wine && wineInfo.wine.picture">
                    <div class="wine-image" :style="getImgUrl(wineInfo.wine.picture.bottlePicture)"></div>
                    <div class="wine-details-container">
                        <v-container class="wine-details-info">
                            <v-flex class="wine-info-wrapper">
                                <div class="wine-details-main">
                                    <div class="wine-details-head">
                                        <div class="left-col">
                                            <div v-if="wineInfo.wine.wineName">
                                                <h2>{{ wineInfo.wine.vintage }} {{ wineInfo.wine.wineName }}</h2>
                                                <h3 v-if="wineInfo.wine.isSecondLabel" class="addition-description">2-nd
                                                    label of {{ wineInfo.wine.producerTypeName }}
                                                    {{ wineInfo.wine.producerName }}</h3>
                                                <h3 v-else class="addition-description">{{ wineInfo.wine.producerTypeName }} {{ wineInfo.wine.producerName }}</h3>
                                            </div>
                                            <div v-else>
                                                <h2>{{ wineInfo.wine.vintage }} {{ wineInfo.wine.producerTypeName }} {{ wineInfo.wine.producerName }}</h2>
                                            </div>
                                            <v-row class="second-row" v-if="mobileCheck">
                                                <v-flex class="wine-details-region">
                                                    <div class="enprimeur" v-if="wineInfo.wine.isEnPrimeur">
                                                        En Primeur
                                                        <div class="info-text">{{ $t('will-be-bottled') }}{{wineInfo.wine.vintage.charAt(2)}}{{parseInt(wineInfo.wine.vintage.charAt(3)) + 3}}</div>
                                                    </div>
                                                    <div class="head-country-el">
                                                        <div>
                                                            <img class="wine-details-img" :src="wineInfo.wine.countryFlagUrl">
                                                        </div>
                                                    </div>
                                                    <div class="head-region-el" style="margin-right: 10px;">
                                                        {{ wineInfo.wine.countryName }}
                                                    </div>
                                                    <div class="head-region-el">
                                                        {{ wineInfo.wine.regionName }}, {{ wineInfo.wine.appellation }}
                                                    </div>
                                                </v-flex>
                                                <v-flex class="wine-details-region" v-if="mobileCheck">
                                                    <div class="winemarket-winecolor-img"
                                                         :class="wineInfo.wine.colorId == 1 ? 'redwine' : (wineInfo.wine.colorId == 2 ? 'whitewine' : 'champagne')"></div>
                                                    <div class="last-trade-el">
                                                        {{ $t(wineInfo.wine.color.toLowerCase()) }}
                                                    </div>
                                                    <div class="last-trade-el last-trade-el-class" v-if="wineInfo.wine.classification">
                                                        {{ wineInfo.wine.classification }}
                                                    </div>
                                                    <div class="last-trade-el">
                                                        {{ $t('last-trade') }}: {{
                                                            wineInfo.wine.lastTraded === null ? '-' : formatDate(wineInfo.wine.lastTraded, 'DD MMM YYYY hh:mm')
                                                        }}
                                                    </div>
                                                </v-flex>
                                            </v-row>
                                        </div>
                                        <div class="right-col producer">
                                            <div class="share-row" v-if="!mobileCheck">
                                                <div class="share-title">{{ $t('share') }}</div>
                                                <ShareNetwork
                                                    network="facebook"
                                                    :url="windowHref"
                                                    :title=wineNameShare
                                                    :description="wineInfo.wine.shortDescription"
                                                    hashtags="wines,invest,vindome"
                                                >
                                                    <svg width="16" height="16" viewBox="0 0 26 24"
                                                         xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M25.6059 11.9991C25.6059 5.37216 19.8738 0 12.803 0C5.73207 0 0 5.37216 0 11.9991C0 17.9882 4.68186 22.9522 10.8025 23.8524V15.4676H7.55174V11.9991H10.8025V9.35553C10.8025 6.34826 12.7139 4.68714 15.6383 4.68714C17.0391 4.68714 18.5043 4.92149 18.5043 4.92149V7.87439H16.8899C15.2994 7.87439 14.8034 8.79933 14.8034 9.74824V11.9991H18.3542L17.7866 15.4676H14.8034V23.8524C20.9241 22.9522 25.6059 17.9882 25.6059 11.9991Z"
                                                            fill="black"/>
                                                    </svg>
                                                </ShareNetwork>
                                                <ShareNetwork
                                                    network="linkedin"
                                                    :url="windowHref"
                                                    :title=wineNameShare
                                                >
                                                    <svg width="16" height="16" viewBox="0 0 26 24"
                                                         xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M22.1743 20.452H18.3822V14.883C18.3822 13.555 18.3534 11.846 16.4061 11.846C14.429 11.846 14.127 13.291 14.127 14.785V20.452H10.3349V9H13.9776V10.561H14.0267C14.5357 9.661 15.7734 8.711 17.6225 8.711C21.4647 8.711 22.1753 11.081 22.1753 14.166V20.452H22.1743ZM6.05197 7.433C4.83133 7.433 3.85076 6.507 3.85076 5.368C3.85076 4.23 4.8324 3.305 6.05197 3.305C7.26835 3.305 8.25425 4.23 8.25425 5.368C8.25425 6.507 7.26728 7.433 6.05197 7.433ZM7.95336 20.452H4.15059V9H7.95336V20.452ZM24.0714 0H2.24707C1.20248 0 0.357422 0.774 0.357422 1.729V22.271C0.357422 23.227 1.20248 24 2.24707 24H24.0682C25.1117 24 25.9653 23.227 25.9653 22.271V1.729C25.9653 0.774 25.1117 0 24.0682 0H24.0714Z"
                                                            fill="black"/>
                                                    </svg>
                                                </ShareNetwork>
                                                <ShareNetwork
                                                    network="whatsapp"
                                                    :url="windowHref"
                                                    :title=wineNameShare
                                                    :description="wineInfo.wine.shortDescription"
                                                >
                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                                         xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M11.6481 9.58803C11.4501 9.48869 10.4761 9.01003 10.2948 8.94336C10.1128 8.87736 9.98075 8.84469 9.84809 9.04336C9.71675 9.24136 9.33675 9.68736 9.22142 9.81936C9.10609 9.95203 8.99009 9.96803 8.79209 9.86936C8.59409 9.76936 7.95542 9.56069 7.19875 8.88603C6.61009 8.36069 6.21209 7.71203 6.09675 7.51336C5.98142 7.31536 6.08475 7.20803 6.18342 7.10936C6.27275 7.02069 6.38209 6.87803 6.48075 6.76269C6.58009 6.64669 6.61275 6.56403 6.67942 6.43136C6.74542 6.29936 6.71275 6.18403 6.66275 6.08469C6.61275 5.98536 6.21675 5.01003 6.05209 4.61336C5.89075 4.22736 5.72742 4.28003 5.60609 4.27336C5.49075 4.26803 5.35875 4.26669 5.22609 4.26669C5.09409 4.26669 4.87942 4.31603 4.69809 4.51469C4.51675 4.71269 4.00475 5.19203 4.00475 6.16736C4.00475 7.14203 4.71475 8.08403 4.81342 8.21669C4.91275 8.34869 6.21075 10.35 8.19809 11.208C8.67075 11.412 9.03942 11.534 9.32742 11.6247C9.80209 11.776 10.2341 11.7547 10.5748 11.7034C10.9554 11.6467 11.7468 11.224 11.9121 10.7614C12.0774 10.2987 12.0774 9.90203 12.0274 9.81936C11.9781 9.73669 11.8461 9.68736 11.6474 9.58803H11.6481ZM8.03342 14.5234H8.03075C6.8506 14.5235 5.69214 14.2062 4.67675 13.6047L4.43609 13.462L1.94209 14.1167L2.60742 11.6847L2.45075 11.4354C1.79105 10.3849 1.44205 9.16915 1.44409 7.92869C1.44475 4.29536 4.40142 1.33936 8.03609 1.33936C9.79609 1.33936 11.4508 2.02603 12.6948 3.27136C13.3085 3.88244 13.795 4.60918 14.1261 5.40952C14.4571 6.20987 14.6262 7.06792 14.6234 7.93403C14.6214 11.5674 11.6654 14.5234 8.03342 14.5234ZM13.6421 2.32536C12.9075 1.58598 12.0336 0.999719 11.0708 0.600561C10.108 0.201403 9.07564 -0.0027175 8.03342 2.73184e-05C3.66342 2.73184e-05 0.106753 3.55669 0.104753 7.92803C0.104753 9.32536 0.469419 10.6894 1.16342 11.8914L0.0380859 16L4.24142 14.8974C5.40381 15.5306 6.70638 15.8625 8.03009 15.8627H8.03342C12.4028 15.8627 15.9601 12.306 15.9621 7.93403C15.9653 6.89221 15.7619 5.86009 15.3637 4.89738C14.9655 3.93467 14.3803 3.06047 13.6421 2.32536Z"
                                                            fill="black"/>
                                                    </svg>
                                                </ShareNetwork>
                                                <ShareNetwork
                                                    network="viber"
                                                    :url="windowHref"
                                                    :title=wineNameShare
                                                    :description="wineInfo.wine.shortDescription"
                                                >
                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                                         xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M13.4817 1.56135C13.0846 1.19332 11.4769 0.0262491 7.89822 0.0117214C7.89822 0.0117214 3.67549 -0.24493 1.60286 1.64368C0.455173 2.79137 0.0532386 4.4669 0.0096554 6.54437C-0.0339278 8.62183 -0.0871966 12.5153 3.6658 13.5709V15.1835C3.6658 15.1835 3.66581 15.8373 4.07258 15.968C4.59074 16.1327 4.89582 15.6339 5.3946 15.1012C5.66579 14.8058 6.04351 14.3748 6.32438 14.0455C7.92109 14.1947 9.53149 14.0769 11.0895 13.6969C11.6076 13.5274 14.5422 13.1545 15.0217 9.25621C15.5301 5.24171 14.7989 2.7042 13.4817 1.56135ZM13.9176 8.9705C13.5108 12.2199 11.1331 12.4233 10.6972 12.5637C9.35672 12.8941 7.97285 13.0134 6.59557 12.9172C6.59557 12.9172 4.96846 14.8542 4.45999 15.3869C4.4317 15.4203 4.39587 15.4466 4.35546 15.4634C4.31504 15.4802 4.27119 15.4872 4.22754 15.4838C4.14038 15.4596 4.11616 15.3579 4.11616 15.2077C4.11616 15.0576 4.11616 12.5298 4.11616 12.5298C0.939431 11.6436 1.12345 8.33128 1.16219 6.59763C1.20093 4.86399 1.52538 3.44027 2.4939 2.48144C4.23239 0.907602 7.82074 1.14004 7.82074 1.14004C10.8474 1.14004 12.3001 2.06498 12.6343 2.37006C13.7626 3.32889 14.3292 5.61459 13.9176 8.9705V8.9705Z"
                                                            fill="#231815"/>
                                                        <path
                                                            d="M9.37037 6.65559C9.31807 6.65565 9.26775 6.63555 9.22987 6.59948C9.192 6.56341 9.16948 6.51413 9.16699 6.46189C9.17971 6.32339 9.16245 6.18377 9.11639 6.05254C9.07033 5.92131 8.99654 5.80153 8.90005 5.70137C8.80356 5.6012 8.68663 5.52299 8.55721 5.47206C8.42779 5.42113 8.28892 5.39866 8.15005 5.4062C8.0961 5.40299 8.04564 5.37848 8.00977 5.33807C7.9739 5.29766 7.95555 5.24465 7.95876 5.19071C7.96198 5.13677 7.98648 5.08631 8.02689 5.05044C8.06731 5.01457 8.12032 4.99621 8.17426 4.99942C8.3642 4.99357 8.55326 5.02757 8.72927 5.09923C8.90527 5.17089 9.06432 5.27861 9.19616 5.41547C9.328 5.55233 9.42972 5.71529 9.49475 5.89385C9.55979 6.07241 9.5867 6.26261 9.57376 6.4522C9.57507 6.47891 9.57109 6.50563 9.56205 6.5308C9.55302 6.55598 9.5391 6.57913 9.52111 6.59892C9.50312 6.61871 9.4814 6.63476 9.4572 6.64614C9.43299 6.65753 9.40678 6.66403 9.38006 6.66527L9.37037 6.65559Z"
                                                            fill="#231815"/>
                                                        <path
                                                            d="M10.4115 7.00438C10.3848 7.00376 10.3585 6.99787 10.334 6.98706C10.3096 6.97626 10.2875 6.96074 10.2691 6.94141C10.2507 6.92207 10.2362 6.89929 10.2266 6.87436C10.217 6.84944 10.2123 6.82287 10.213 6.79616C10.2312 6.48525 10.1871 6.17383 10.0831 5.88025C9.97915 5.58667 9.81749 5.31687 9.60765 5.08673C9.14482 4.60737 8.51114 4.33057 7.84495 4.31675C7.81596 4.31862 7.78691 4.31426 7.75974 4.30397C7.73258 4.29367 7.70793 4.27767 7.68747 4.25705C7.66701 4.23643 7.6512 4.21167 7.64111 4.18442C7.63102 4.15718 7.62688 4.1281 7.62898 4.09912C7.63107 4.07015 7.63935 4.04196 7.65325 4.01645C7.66716 3.99094 7.68636 3.96871 7.70958 3.95124C7.7328 3.93378 7.75948 3.9215 7.78785 3.91521C7.81621 3.90893 7.84559 3.9088 7.87401 3.91482C8.64309 3.93577 9.3733 4.2574 9.90789 4.81069C10.3941 5.35046 10.6466 6.06092 10.6101 6.78647C10.6128 6.81412 10.6097 6.84204 10.6009 6.86841C10.5921 6.89478 10.5779 6.91902 10.5592 6.93956C10.5405 6.9601 10.5177 6.97648 10.4923 6.98765C10.4668 6.99881 10.4393 7.00452 10.4115 7.00438V7.00438Z"
                                                            fill="#231815"/>
                                                        <path
                                                            d="M11.4721 7.42082C11.4181 7.42082 11.3664 7.39939 11.3282 7.36125C11.2901 7.3231 11.2687 7.27137 11.2687 7.21743C11.2971 6.68418 11.215 6.15081 11.0275 5.6508C10.84 5.15079 10.5511 4.69494 10.1791 4.31188C9.82476 3.96579 9.40503 3.69376 8.9444 3.51167C8.48378 3.32958 7.9915 3.24109 7.4963 3.25136C7.44235 3.25136 7.39062 3.22993 7.35248 3.19178C7.31433 3.15364 7.29291 3.10191 7.29291 3.04797C7.29291 2.99403 7.31433 2.9423 7.35248 2.90415C7.39062 2.86601 7.44235 2.84458 7.4963 2.84458C8.04351 2.83537 8.58714 2.93461 9.0958 3.13658C9.60447 3.33855 10.0681 3.63925 10.46 4.02132C10.8671 4.44076 11.1844 4.93878 11.3925 5.48498C11.6007 6.03117 11.6953 6.61407 11.6706 7.19806C11.6706 7.25201 11.6492 7.30374 11.611 7.34188C11.5729 7.38002 11.5212 7.40145 11.4672 7.40145L11.4721 7.42082Z"
                                                            fill="#231815"/>
                                                        <path
                                                            d="M8.20329 9.16411C8.28355 9.17009 8.36414 9.15846 8.43943 9.13002C8.51471 9.10158 8.58287 9.05702 8.63912 8.99946L8.93936 8.62174C9.04216 8.50861 9.1816 8.43541 9.33309 8.41504C9.48458 8.39466 9.63841 8.42842 9.76745 8.51036C10.0244 8.65856 10.2733 8.82021 10.5132 8.99462C10.7408 9.16411 11.2009 9.54668 11.2009 9.55152C11.3092 9.63917 11.3815 9.76369 11.4038 9.90127C11.4262 10.0389 11.397 10.1798 11.3219 10.2973V10.2973C11.1571 10.5835 10.9479 10.8418 10.7021 11.0624V11.0624C10.5247 11.2235 10.3043 11.3295 10.0677 11.3675C10.0372 11.3727 10.0061 11.3727 9.97567 11.3675C9.8854 11.3688 9.79548 11.3558 9.70933 11.3287V11.3287C9.10577 11.1201 8.52492 10.8507 7.97569 10.5249C7.46449 10.2444 6.97843 9.92037 6.52292 9.55636C6.29408 9.3753 6.0758 9.18128 5.86917 8.97525V8.97525H5.84495C5.64015 8.76577 5.4462 8.54595 5.26385 8.31666C4.90146 7.85996 4.57752 7.37404 4.29533 6.86389C3.96935 6.3154 3.70155 5.73437 3.4963 5.13024C3.46769 5.04268 3.45299 4.95117 3.45272 4.85906C3.4498 4.82846 3.4498 4.79765 3.45272 4.76705C3.48997 4.53166 3.59613 4.3126 3.7578 4.13751V4.13751C3.94408 3.85542 4.17464 3.60524 4.44061 3.3966V3.3966C4.55879 3.32119 4.70056 3.29185 4.83896 3.31418C4.97736 3.3365 5.10273 3.40892 5.19121 3.51766C5.19121 3.51766 5.57861 4.00192 5.74326 4.20531C5.90791 4.40869 6.1113 4.76221 6.22752 4.95107C6.30737 5.08195 6.33943 5.23644 6.31825 5.38829C6.29706 5.54014 6.22393 5.67996 6.1113 5.78398L5.73358 6.07938C5.67591 6.13657 5.63132 6.20558 5.6029 6.28165C5.57447 6.35773 5.56288 6.43907 5.56893 6.52006C5.75345 7.14512 6.091 7.71428 6.551 8.17597C7.011 8.63766 7.57891 8.97729 8.20329 9.16411Z"
                                                            fill="#231815"/>
                                                    </svg>
                                                </ShareNetwork>
                                                <ShareNetwork
                                                    network="twitter"
                                                    :url="windowHref"
                                                    :title=wineNameShare
                                                    :description="wineInfo.wine.shortDescription"
                                                    hashtags="wines,invest,vindome"
                                                >
                                                    <svg width="16" height="13" viewBox="0 0 26 20"
                                                         xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M25.5959 2.56897C24.6516 2.95797 23.6433 3.22297 22.5816 3.34397C23.6636 2.73297 24.4958 1.76997 24.8896 0.620972C23.8748 1.17597 22.7502 1.57997 21.5531 1.80497C20.597 0.845972 19.2345 0.245972 17.7215 0.245972C14.8225 0.245972 12.4719 2.44897 12.4719 5.16297C12.4719 5.55297 12.5199 5.92797 12.6074 6.28697C8.24337 6.09397 4.37551 4.12997 1.78698 1.16097C1.33137 1.88297 1.07636 2.72197 1.07636 3.63597C1.07636 5.34597 2.00465 6.84897 3.41095 7.73197C2.54988 7.70597 1.74003 7.48397 1.03368 7.11597V7.17697C1.03368 9.56197 2.84011 11.551 5.24405 12.004C4.80338 12.115 4.33817 12.175 3.86122 12.175C3.52618 12.175 3.20502 12.145 2.88385 12.089C3.55713 14.042 5.49265 15.466 7.7963 15.506C6.00375 16.825 3.73211 17.611 1.28549 17.611C0.869365 17.611 0.454304 17.588 0.0371094 17.544C2.37276 18.938 5.12454 19.753 8.10039 19.753C17.761 19.753 23.0373 12.257 23.0373 5.76697C23.0373 5.55797 23.0373 5.34697 23.0212 5.13697C24.0466 4.44797 24.9418 3.57697 25.6461 2.58897L25.5959 2.56897Z"
                                                            fill="black"/>
                                                    </svg>
                                                </ShareNetwork>
                                                <ShareNetwork
                                                    network="email"
                                                    :url="windowHref"
                                                    :title="wineNameShare"
                                                    :description="wineInfo.wine.shortDescription"
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" height="24"
                                                         viewBox="0 0 24 24" width="24">
                                                        <path d="M0 0h24v24H0z" fill="none"/>
                                                        <path
                                                            d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                                                    </svg>
                                                </ShareNetwork>
                                            </div>
                                            <div class="back-order" v-on:click="$router.go(-1)">
                                                <div>{{ $t('back') }}</div>
                                                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24"
                                                     width="24">
                                                    <path d="M0 0h24v24H0z" fill="none"/>
                                                    <path
                                                        d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
                                                </svg>
                                            </div>
                                        </div>

                                        <div class="enprimeur" v-if="!mobileCheck && wineInfo.wine.isEnPrimeur">
                                            En Primeur
                                            <div class="info-text">{{ $t('will-be-bottled') }}{{wineInfo.wine.vintage.charAt(2)}}{{parseInt(wineInfo.wine.vintage.charAt(3)) + 3}}</div>
                                        </div>
                                        <v-flex class="wine-details-region" v-if="!mobileCheck">
                                            <div class="head-country-el">
                                                <div>
                                                    <img class="wine-details-img" :src="wineInfo.wine.countryFlagUrl">
                                                </div>
                                                {{ wineInfo.wine.countryName }}
                                            </div>
                                            <div class="head-region-el">
                                                {{ wineInfo.wine.regionName }}, {{ wineInfo.wine.appellation }}
                                            </div>
                                            <div class="winemarket-winecolor-img"
                                                 :class="wineInfo.wine.colorId == 1 ? 'redwine' : (wineInfo.wine.colorId == 2 ? 'whitewine' : 'champagne')"></div>
                                            <div class="last-trade-el">
                                                {{ $t(wineInfo.wine.color.toLowerCase()) }}
                                            </div>
                                            <div class="last-trade-el last-trade-el-class" v-if="wineInfo.wine.classification">
                                                {{ wineInfo.wine.classification }}
                                            </div>
                                            <div class="last-trade-el right-side">
                                                {{ $t('last-trade') }}: {{
                                                    wineInfo.wine.lastTraded === null ? '-' : formatDate(wineInfo.wine.lastTraded, 'DD MMM YYYY hh:mm')
                                                }}
                                            </div>
                                        </v-flex>





                                    </div>

                                    <div class="share-row-mobile" v-if="mobileCheck">
                                        <div class="share-title">{{ $t('share') }}</div>
                                        <ShareNetwork
                                            network="facebook"
                                            :url="windowHref"
                                            :title=wineNameShare
                                            :description="wineInfo.wine.shortDescription"
                                            hashtags="wines,invest,vindome"
                                        >
                                            <svg width="16" height="16" viewBox="0 0 26 24"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M25.6059 11.9991C25.6059 5.37216 19.8738 0 12.803 0C5.73207 0 0 5.37216 0 11.9991C0 17.9882 4.68186 22.9522 10.8025 23.8524V15.4676H7.55174V11.9991H10.8025V9.35553C10.8025 6.34826 12.7139 4.68714 15.6383 4.68714C17.0391 4.68714 18.5043 4.92149 18.5043 4.92149V7.87439H16.8899C15.2994 7.87439 14.8034 8.79933 14.8034 9.74824V11.9991H18.3542L17.7866 15.4676H14.8034V23.8524C20.9241 22.9522 25.6059 17.9882 25.6059 11.9991Z"
                                                    fill="black"/>
                                            </svg>
                                        </ShareNetwork>
                                        <ShareNetwork
                                            network="linkedin"
                                            :url="windowHref"
                                            :title=wineNameShare
                                        >
                                            <svg width="16" height="16" viewBox="0 0 26 24"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M22.1743 20.452H18.3822V14.883C18.3822 13.555 18.3534 11.846 16.4061 11.846C14.429 11.846 14.127 13.291 14.127 14.785V20.452H10.3349V9H13.9776V10.561H14.0267C14.5357 9.661 15.7734 8.711 17.6225 8.711C21.4647 8.711 22.1753 11.081 22.1753 14.166V20.452H22.1743ZM6.05197 7.433C4.83133 7.433 3.85076 6.507 3.85076 5.368C3.85076 4.23 4.8324 3.305 6.05197 3.305C7.26835 3.305 8.25425 4.23 8.25425 5.368C8.25425 6.507 7.26728 7.433 6.05197 7.433ZM7.95336 20.452H4.15059V9H7.95336V20.452ZM24.0714 0H2.24707C1.20248 0 0.357422 0.774 0.357422 1.729V22.271C0.357422 23.227 1.20248 24 2.24707 24H24.0682C25.1117 24 25.9653 23.227 25.9653 22.271V1.729C25.9653 0.774 25.1117 0 24.0682 0H24.0714Z"
                                                    fill="black"/>
                                            </svg>
                                        </ShareNetwork>
                                        <ShareNetwork
                                            network="whatsapp"
                                            :url="windowHref"
                                            :title=wineNameShare
                                            :description="wineInfo.wine.shortDescription"
                                        >
                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M11.6481 9.58803C11.4501 9.48869 10.4761 9.01003 10.2948 8.94336C10.1128 8.87736 9.98075 8.84469 9.84809 9.04336C9.71675 9.24136 9.33675 9.68736 9.22142 9.81936C9.10609 9.95203 8.99009 9.96803 8.79209 9.86936C8.59409 9.76936 7.95542 9.56069 7.19875 8.88603C6.61009 8.36069 6.21209 7.71203 6.09675 7.51336C5.98142 7.31536 6.08475 7.20803 6.18342 7.10936C6.27275 7.02069 6.38209 6.87803 6.48075 6.76269C6.58009 6.64669 6.61275 6.56403 6.67942 6.43136C6.74542 6.29936 6.71275 6.18403 6.66275 6.08469C6.61275 5.98536 6.21675 5.01003 6.05209 4.61336C5.89075 4.22736 5.72742 4.28003 5.60609 4.27336C5.49075 4.26803 5.35875 4.26669 5.22609 4.26669C5.09409 4.26669 4.87942 4.31603 4.69809 4.51469C4.51675 4.71269 4.00475 5.19203 4.00475 6.16736C4.00475 7.14203 4.71475 8.08403 4.81342 8.21669C4.91275 8.34869 6.21075 10.35 8.19809 11.208C8.67075 11.412 9.03942 11.534 9.32742 11.6247C9.80209 11.776 10.2341 11.7547 10.5748 11.7034C10.9554 11.6467 11.7468 11.224 11.9121 10.7614C12.0774 10.2987 12.0774 9.90203 12.0274 9.81936C11.9781 9.73669 11.8461 9.68736 11.6474 9.58803H11.6481ZM8.03342 14.5234H8.03075C6.8506 14.5235 5.69214 14.2062 4.67675 13.6047L4.43609 13.462L1.94209 14.1167L2.60742 11.6847L2.45075 11.4354C1.79105 10.3849 1.44205 9.16915 1.44409 7.92869C1.44475 4.29536 4.40142 1.33936 8.03609 1.33936C9.79609 1.33936 11.4508 2.02603 12.6948 3.27136C13.3085 3.88244 13.795 4.60918 14.1261 5.40952C14.4571 6.20987 14.6262 7.06792 14.6234 7.93403C14.6214 11.5674 11.6654 14.5234 8.03342 14.5234ZM13.6421 2.32536C12.9075 1.58598 12.0336 0.999719 11.0708 0.600561C10.108 0.201403 9.07564 -0.0027175 8.03342 2.73184e-05C3.66342 2.73184e-05 0.106753 3.55669 0.104753 7.92803C0.104753 9.32536 0.469419 10.6894 1.16342 11.8914L0.0380859 16L4.24142 14.8974C5.40381 15.5306 6.70638 15.8625 8.03009 15.8627H8.03342C12.4028 15.8627 15.9601 12.306 15.9621 7.93403C15.9653 6.89221 15.7619 5.86009 15.3637 4.89738C14.9655 3.93467 14.3803 3.06047 13.6421 2.32536Z"
                                                    fill="black"/>
                                            </svg>
                                        </ShareNetwork>
                                        <ShareNetwork
                                            network="viber"
                                            :url="windowHref"
                                            :title=wineNameShare
                                            :description="wineInfo.wine.shortDescription"
                                        >
                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M13.4817 1.56135C13.0846 1.19332 11.4769 0.0262491 7.89822 0.0117214C7.89822 0.0117214 3.67549 -0.24493 1.60286 1.64368C0.455173 2.79137 0.0532386 4.4669 0.0096554 6.54437C-0.0339278 8.62183 -0.0871966 12.5153 3.6658 13.5709V15.1835C3.6658 15.1835 3.66581 15.8373 4.07258 15.968C4.59074 16.1327 4.89582 15.6339 5.3946 15.1012C5.66579 14.8058 6.04351 14.3748 6.32438 14.0455C7.92109 14.1947 9.53149 14.0769 11.0895 13.6969C11.6076 13.5274 14.5422 13.1545 15.0217 9.25621C15.5301 5.24171 14.7989 2.7042 13.4817 1.56135ZM13.9176 8.9705C13.5108 12.2199 11.1331 12.4233 10.6972 12.5637C9.35672 12.8941 7.97285 13.0134 6.59557 12.9172C6.59557 12.9172 4.96846 14.8542 4.45999 15.3869C4.4317 15.4203 4.39587 15.4466 4.35546 15.4634C4.31504 15.4802 4.27119 15.4872 4.22754 15.4838C4.14038 15.4596 4.11616 15.3579 4.11616 15.2077C4.11616 15.0576 4.11616 12.5298 4.11616 12.5298C0.939431 11.6436 1.12345 8.33128 1.16219 6.59763C1.20093 4.86399 1.52538 3.44027 2.4939 2.48144C4.23239 0.907602 7.82074 1.14004 7.82074 1.14004C10.8474 1.14004 12.3001 2.06498 12.6343 2.37006C13.7626 3.32889 14.3292 5.61459 13.9176 8.9705V8.9705Z"
                                                    fill="#231815"/>
                                                <path
                                                    d="M9.37037 6.65559C9.31807 6.65565 9.26775 6.63555 9.22987 6.59948C9.192 6.56341 9.16948 6.51413 9.16699 6.46189C9.17971 6.32339 9.16245 6.18377 9.11639 6.05254C9.07033 5.92131 8.99654 5.80153 8.90005 5.70137C8.80356 5.6012 8.68663 5.52299 8.55721 5.47206C8.42779 5.42113 8.28892 5.39866 8.15005 5.4062C8.0961 5.40299 8.04564 5.37848 8.00977 5.33807C7.9739 5.29766 7.95555 5.24465 7.95876 5.19071C7.96198 5.13677 7.98648 5.08631 8.02689 5.05044C8.06731 5.01457 8.12032 4.99621 8.17426 4.99942C8.3642 4.99357 8.55326 5.02757 8.72927 5.09923C8.90527 5.17089 9.06432 5.27861 9.19616 5.41547C9.328 5.55233 9.42972 5.71529 9.49475 5.89385C9.55979 6.07241 9.5867 6.26261 9.57376 6.4522C9.57507 6.47891 9.57109 6.50563 9.56205 6.5308C9.55302 6.55598 9.5391 6.57913 9.52111 6.59892C9.50312 6.61871 9.4814 6.63476 9.4572 6.64614C9.43299 6.65753 9.40678 6.66403 9.38006 6.66527L9.37037 6.65559Z"
                                                    fill="#231815"/>
                                                <path
                                                    d="M10.4115 7.00438C10.3848 7.00376 10.3585 6.99787 10.334 6.98706C10.3096 6.97626 10.2875 6.96074 10.2691 6.94141C10.2507 6.92207 10.2362 6.89929 10.2266 6.87436C10.217 6.84944 10.2123 6.82287 10.213 6.79616C10.2312 6.48525 10.1871 6.17383 10.0831 5.88025C9.97915 5.58667 9.81749 5.31687 9.60765 5.08673C9.14482 4.60737 8.51114 4.33057 7.84495 4.31675C7.81596 4.31862 7.78691 4.31426 7.75974 4.30397C7.73258 4.29367 7.70793 4.27767 7.68747 4.25705C7.66701 4.23643 7.6512 4.21167 7.64111 4.18442C7.63102 4.15718 7.62688 4.1281 7.62898 4.09912C7.63107 4.07015 7.63935 4.04196 7.65325 4.01645C7.66716 3.99094 7.68636 3.96871 7.70958 3.95124C7.7328 3.93378 7.75948 3.9215 7.78785 3.91521C7.81621 3.90893 7.84559 3.9088 7.87401 3.91482C8.64309 3.93577 9.3733 4.2574 9.90789 4.81069C10.3941 5.35046 10.6466 6.06092 10.6101 6.78647C10.6128 6.81412 10.6097 6.84204 10.6009 6.86841C10.5921 6.89478 10.5779 6.91902 10.5592 6.93956C10.5405 6.9601 10.5177 6.97648 10.4923 6.98765C10.4668 6.99881 10.4393 7.00452 10.4115 7.00438V7.00438Z"
                                                    fill="#231815"/>
                                                <path
                                                    d="M11.4721 7.42082C11.4181 7.42082 11.3664 7.39939 11.3282 7.36125C11.2901 7.3231 11.2687 7.27137 11.2687 7.21743C11.2971 6.68418 11.215 6.15081 11.0275 5.6508C10.84 5.15079 10.5511 4.69494 10.1791 4.31188C9.82476 3.96579 9.40503 3.69376 8.9444 3.51167C8.48378 3.32958 7.9915 3.24109 7.4963 3.25136C7.44235 3.25136 7.39062 3.22993 7.35248 3.19178C7.31433 3.15364 7.29291 3.10191 7.29291 3.04797C7.29291 2.99403 7.31433 2.9423 7.35248 2.90415C7.39062 2.86601 7.44235 2.84458 7.4963 2.84458C8.04351 2.83537 8.58714 2.93461 9.0958 3.13658C9.60447 3.33855 10.0681 3.63925 10.46 4.02132C10.8671 4.44076 11.1844 4.93878 11.3925 5.48498C11.6007 6.03117 11.6953 6.61407 11.6706 7.19806C11.6706 7.25201 11.6492 7.30374 11.611 7.34188C11.5729 7.38002 11.5212 7.40145 11.4672 7.40145L11.4721 7.42082Z"
                                                    fill="#231815"/>
                                                <path
                                                    d="M8.20329 9.16411C8.28355 9.17009 8.36414 9.15846 8.43943 9.13002C8.51471 9.10158 8.58287 9.05702 8.63912 8.99946L8.93936 8.62174C9.04216 8.50861 9.1816 8.43541 9.33309 8.41504C9.48458 8.39466 9.63841 8.42842 9.76745 8.51036C10.0244 8.65856 10.2733 8.82021 10.5132 8.99462C10.7408 9.16411 11.2009 9.54668 11.2009 9.55152C11.3092 9.63917 11.3815 9.76369 11.4038 9.90127C11.4262 10.0389 11.397 10.1798 11.3219 10.2973V10.2973C11.1571 10.5835 10.9479 10.8418 10.7021 11.0624V11.0624C10.5247 11.2235 10.3043 11.3295 10.0677 11.3675C10.0372 11.3727 10.0061 11.3727 9.97567 11.3675C9.8854 11.3688 9.79548 11.3558 9.70933 11.3287V11.3287C9.10577 11.1201 8.52492 10.8507 7.97569 10.5249C7.46449 10.2444 6.97843 9.92037 6.52292 9.55636C6.29408 9.3753 6.0758 9.18128 5.86917 8.97525V8.97525H5.84495C5.64015 8.76577 5.4462 8.54595 5.26385 8.31666C4.90146 7.85996 4.57752 7.37404 4.29533 6.86389C3.96935 6.3154 3.70155 5.73437 3.4963 5.13024C3.46769 5.04268 3.45299 4.95117 3.45272 4.85906C3.4498 4.82846 3.4498 4.79765 3.45272 4.76705C3.48997 4.53166 3.59613 4.3126 3.7578 4.13751V4.13751C3.94408 3.85542 4.17464 3.60524 4.44061 3.3966V3.3966C4.55879 3.32119 4.70056 3.29185 4.83896 3.31418C4.97736 3.3365 5.10273 3.40892 5.19121 3.51766C5.19121 3.51766 5.57861 4.00192 5.74326 4.20531C5.90791 4.40869 6.1113 4.76221 6.22752 4.95107C6.30737 5.08195 6.33943 5.23644 6.31825 5.38829C6.29706 5.54014 6.22393 5.67996 6.1113 5.78398L5.73358 6.07938C5.67591 6.13657 5.63132 6.20558 5.6029 6.28165C5.57447 6.35773 5.56288 6.43907 5.56893 6.52006C5.75345 7.14512 6.091 7.71428 6.551 8.17597C7.011 8.63766 7.57891 8.97729 8.20329 9.16411Z"
                                                    fill="#231815"/>
                                            </svg>
                                        </ShareNetwork>
                                        <ShareNetwork
                                            network="twitter"
                                            :url="windowHref"
                                            :title=wineNameShare
                                            :description="wineInfo.wine.shortDescription"
                                            hashtags="wines,invest,vindome"
                                        >
                                            <svg width="16" height="13" viewBox="0 0 26 20"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M25.5959 2.56897C24.6516 2.95797 23.6433 3.22297 22.5816 3.34397C23.6636 2.73297 24.4958 1.76997 24.8896 0.620972C23.8748 1.17597 22.7502 1.57997 21.5531 1.80497C20.597 0.845972 19.2345 0.245972 17.7215 0.245972C14.8225 0.245972 12.4719 2.44897 12.4719 5.16297C12.4719 5.55297 12.5199 5.92797 12.6074 6.28697C8.24337 6.09397 4.37551 4.12997 1.78698 1.16097C1.33137 1.88297 1.07636 2.72197 1.07636 3.63597C1.07636 5.34597 2.00465 6.84897 3.41095 7.73197C2.54988 7.70597 1.74003 7.48397 1.03368 7.11597V7.17697C1.03368 9.56197 2.84011 11.551 5.24405 12.004C4.80338 12.115 4.33817 12.175 3.86122 12.175C3.52618 12.175 3.20502 12.145 2.88385 12.089C3.55713 14.042 5.49265 15.466 7.7963 15.506C6.00375 16.825 3.73211 17.611 1.28549 17.611C0.869365 17.611 0.454304 17.588 0.0371094 17.544C2.37276 18.938 5.12454 19.753 8.10039 19.753C17.761 19.753 23.0373 12.257 23.0373 5.76697C23.0373 5.55797 23.0373 5.34697 23.0212 5.13697C24.0466 4.44797 24.9418 3.57697 25.6461 2.58897L25.5959 2.56897Z"
                                                    fill="black"/>
                                            </svg>
                                        </ShareNetwork>
                                        <ShareNetwork
                                            network="email"
                                            :url="windowHref"
                                            :title="wineNameShare"
                                            :description="wineInfo.wine.shortDescription"
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24"
                                                 width="24">
                                                <path d="M0 0h24v24H0z" fill="none"/>
                                                <path
                                                    d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                                            </svg>
                                        </ShareNetwork>
                                    </div>

                                    <div class="lang-wrapper" v-if="wineInfo.wine.shortDescription != ''">
                                        <span>{{ $t('translate-to') }}:</span>
                                        <div class="lang-item" v-on:click="translateTo('en')"
                                             style="align-items: center">
                                            <img class="wine-image2 wine-image3" src="../../../../assets/home/en.png"/>
                                        </div>
                                        <div class="lang-item" v-on:click="translateTo('it')"
                                             style="align-items: center">
                                            <img class="wine-image2" src="../../../../assets/home/it.png"/>
                                        </div>
                                        <div class="lang-item" v-on:click="translateTo('fr')"
                                             style="align-items: center">
                                            <img class="wine-image2" src="../../../../assets/home/fr.png"/>
                                        </div>
                                        <div class="lang-item" v-on:click="translateTo('de')"
                                             style="align-items: center">
                                            <img class="wine-image2" src="../../../../assets/home/de.png"/>
                                        </div>
                                        <div class="lang-item" v-on:click="translateTo('ru')"
                                             style="align-items: center">
                                            <img class="wine-image2" src="../../../../assets/home/ru.png"/>
                                        </div>
                                    </div>
                                    <v-flex class="wine-details-shortdesc" v-if="wineInfo.wine.shortDescription != ''"
                                            v-html="desc"></v-flex>
                                    <v-flex class="wine-details-shortdesc" v-else>No description available for this
                                        wine.
                                    </v-flex>

                                    <div class="maturity" v-if="wineInfo.wine.drinkFrom">
                                        <label>Maturity:</label> {{ wineInfo.wine.drinkFrom }} -
                                        {{ wineInfo.wine.drinkTo }}
                                    </div>

                                    <div class="sat-container" v-if="wineInfo.wineGrapes">
                                        <div class="rating-title"
                                             v-if="wineInfo.wineGrapes.grapes[wineInfo.wine.vintage]">{{ $t('grape') }}
                                        </div>
                                        <div class="grapes-wrapper"
                                             v-if="wineInfo.wineGrapes.grapes[wineInfo.wine.vintage]">
                                            <div class="grape-item"
                                                 v-for="(grapeItem, index) in wineInfo.wineGrapes.grapes[wineInfo.wine.vintage]"
                                                 :key="index">
                                                <div class="grape-percent">{{ grapeItem.percentage }}<span
                                                    class="grape-percent-span">%</span></div>
                                                <div class="grape-title">{{ grapeItem.grape }}</div>
                                            </div>
                                        </div>

                                        <div class="saturnalia-btn" v-on:click="showSaturnalia">{{
                                                $t('saturnalia1')
                                            }}
                                        </div>
                                    </div>

                                    <div class="rating-title">{{ $t('ratings') }}</div>
                                    <v-layout>
                                        <v-flex class="rating-item">
                                            <div class="rating-value">
                                                {{ wineInfo.wine.ratings.wineAdvocate || '-' }}<span>/100</span></div>
                                            <div class="rating-logo rating-logo1"></div>
                                        </v-flex>
                                        <v-flex class="rating-item">
                                            <div class="rating-value">
                                                {{ wineInfo.wine.ratings.nealMartin || '-' }}<span>/100</span></div>
                                            <div class="rating-logo rating-logo2"></div>
                                        </v-flex>
                                        <v-flex class="rating-item">
                                            <div class="rating-value">
                                                {{ wineInfo.wine.ratings.wineSpectator || '-' }}<span>/100</span></div>
                                            <div class="rating-logo rating-logo3"></div>
                                        </v-flex>
                                        <v-flex class="rating-item">
                                            <div class="rating-value">
                                                {{ wineInfo.wine.ratings.jancisRobinson || '-' }}<span>/20</span></div>
                                            <div class="rating-logo rating-logo4"></div>
                                        </v-flex>
                                        <v-flex class="rating-item">
                                            <div class="rating-value">
                                                {{ wineInfo.wine.ratings.antonioGalloni || '-' }}<span>/100</span></div>
                                            <div class="rating-logo rating-logo5"></div>
                                        </v-flex>
                                    </v-layout>
                                </div>

                                <v-flex class="offers winemarket-table">
                                    <v-row no-gutters>
                                        <div class="offers-item col-2" no-gutters>
                                            <div class="offers-label">{{ $t('case-size') }}</div>
                                            <div>{{ wineInfo.wine.caseSize }}l</div>
                                        </div>
                                        <div class="offers-item col-2" no-gutters>
                                            <div class="offers-label">Best buy</div>
                                            <div class="bold">{{
                                                    wineInfo.wine.minBuyPrice ? formatPrice(wineInfo.wine.minBuyPrice.toLocaleString("fi-FI", {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    }).replace(',', '.')) : '-'
                                                }}
                                            </div>
                                        </div>
                                        <div class="offers-item col-2" no-gutters>
                                            <div class="offers-label">Best sell</div>
                                            <div class="bold">{{
                                                    wineInfo.wine.maxSellPrice ? formatPrice(wineInfo.wine.maxSellPrice.toLocaleString("fi-FI", {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    }).replace(',', '.')) : '-'
                                                }}
                                            </div>
                                        </div>
                                        <div class="offers-item col-2" no-gutters>
                                            <div class="offers-label">Last trade</div>
                                            <div class="bold">{{
                                                    wineInfo.wine.lastTradePrice ? formatPrice(wineInfo.wine.lastTradePrice.toLocaleString("fi-FI", {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    }).replace(',', '.')) : '-'
                                                }}
                                            </div>
                                            <div
                                                :class="wineInfo.wine.change > -1 ? 'winemarket-change positive' : 'winemarket-change negative'">
                                                {{ wineInfo.wine.change ? wineInfo.wine.change.toFixed(2) : '0.00' }}%
                                                <div></div>
                                            </div>
                                        </div>
                                        <div class="offers-item col-4 btn-wrapper" no-gutters>
                                            <div class="market-btn-col2 market-btn-col22">
                                                <button class="btn-secondary market-btn market-btn-sell"
                                                        v-on:click="() => selectWine(wineInfo.wine, false)"
                                                        :disabled="checkWineSell(wineInfo.wine)">{{ $t('sell') }}
                                                </button>
                                            </div>
                                            <div class="market-btn-col2"
                                                 v-on:click="() => selectWine(wineInfo.wine, true)">
                                                <div class="btn-secondary market-btn ga4-buy-wine">{{ $t('buy') }}</div>
                                            </div>
                                        </div>
                                    </v-row>
                                </v-flex>

                                <h4>{{ $t('all-case-sizes') }}</h4>
                                <v-data-table v-if="!mobileCheck" :headers="headers" :items="filteredItems"
                                              :items-per-page="4" hide-default-footer disable-sort fixed-header
                                              class="winemarket-table winemarket-table-details">
                                    <template v-slot:item="{ item }">
                                        <tr>
                                            <td class="winedetails-winesize-td">
                                                {{ item.size }}l
                                                <div>&nbsp;</div>
                                            </td>
                                            <td class="text-right">
                                                {{
                                                    formatPrice(item.buyPrice.toLocaleString("fi-FI", {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    }).replace(',', '.'))
                                                }}
                                                <div>&nbsp;</div>
                                            </td>
                                            <td class="text-right">
                                                {{
                                                    formatPrice(item.sellPrice.toLocaleString("fi-FI", {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    }).replace(',', '.'))
                                                }}
                                                <div>&nbsp;</div>
                                            </td>
                                            <td class="text-right">
                                                {{
                                                    item.lastTradePrice == null ? '-' : formatPrice(item.lastTradePrice.toLocaleString("fi-FI", {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    }).replace(',', '.'))
                                                }}
                                                <div class="winemarket-change"
                                                     :class="item.change > -1 ? 'positive' : (item.change == null ? '' : 'negative')">
                                                    {{ item.change == null ? '0.00%' : `${item.change.toFixed(2)}%` }}
                                                    <div></div>
                                                </div>
                                            </td>
                                            <td>
                                                <button v-on:click="(event) => toggleFav(event, item)"
                                                        :class="item.isFavourite ? 'wine-star active' : 'wine-star'"></button>
                                            </td>
                                            <td class="market-btn-col half-padding-right">
                                                <button class="btn-secondary market-btn"
                                                        v-on:click="() => selectWine(item, false)"
                                                        :disabled="checkWineSell(item)">{{ $t('sell') }}
                                                </button>
                                            </td>
                                            <td class="market-btn-col half-padding-left no-padding-right">
                                                <div class="btn-secondary market-btn ga4-buy-wine"
                                                     v-on:click="() => selectWine(item, true)">{{ $t('buy') }}
                                                </div>
                                            </td>
                                        </tr>
                                    </template>

                                    <template slot="no-data">
                                        <v-alert dense type="info" class="no-orders-info">There are no orders.</v-alert>
                                    </template>
                                </v-data-table>
                                <div class="mobile-all-cases-wrapper" v-else>
                                    <div class="mobile-wines-header">
                                        <div>{{ $t('case-size') }}</div>
                                        <div>Favourites</div>
                                        <div>Best buy</div>
                                        <div>Best sell</div>
                                        <div>Last trade</div>
                                        <div>Last trade %</div>
                                    </div>
                                    <div class="mobile-wines-body">
                                        <div class="mobile-wines-row" v-for="(item, index) in filteredItems"
                                             :key="index">
                                            <div class="mobile-wines-div wineitem-td">
                                                {{ item.size }}l
                                            </div>
                                            <div class="mobile-wines-div wineitem-td">
                                                <button v-on:click="(event) => toggleFav(event, item)"
                                                        :class="item.isFavourite ? 'wine-star active' : 'wine-star'"></button>
                                            </div>
                                            <div class="mobile-wines-div wineitem-td">
                                                {{
                                                    formatPrice(item.buyPrice.toLocaleString("fi-FI", {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    }).replace(',', '.'))
                                                }}
                                            </div>
                                            <div class="mobile-wines-div wineitem-td">
                                                {{
                                                    formatPrice(item.sellPrice.toLocaleString("fi-FI", {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    }).replace(',', '.'))
                                                }}
                                            </div>
                                            <div class="mobile-wines-div wineitem-td">
                                                {{
                                                    item.lastTradePrice == null ? '-' : formatPrice(item.lastTradePrice.toLocaleString("fi-FI", {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    }).replace(',', '.'))
                                                }}
                                            </div>
                                            <div class="mobile-wines-div wineitem-td">
                                                <div class="winemarket-change"
                                                     :class="item.change > -1 ? 'positive' : (item.change == null ? '' : 'negative')">
                                                    {{ item.change == null ? '0.00%' : `${item.change.toFixed(2)}%` }}
                                                    <div></div>
                                                </div>
                                            </div>
                                            <div class="mobile-wines-div market-btn-col half-padding-right">
                                                <button class="btn-secondary market-btn"
                                                        v-on:click="() => selectWine(item, false)" disabled>
                                                    {{ $t('sell') }}
                                                </button>
                                            </div>
                                            <div
                                                class="mobile-wines-div market-btn-col half-padding-left no-padding-right">
                                                <div class="btn-secondary market-btn ga4-buy-wine"
                                                     v-on:click="() => selectWine(item, true)">{{ $t('buy') }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <h4 class="my-investments-h5">{{ $t('my-investments') }}</h4>
                                <v-flex class="my-investments">
                                    <div class="investments-item bottles">
                                        <div class="investments-label">{{ $t('sell1') }}</div>
                                        <div class="bold">{{ portfolioValues.cases }}</div>
                                    </div>
                                    <div class="investments-item medium-bottles">
                                        <div class="investments-label">{{ $t('sell2') }}</div>
                                        <div class="bold">{{ portfolioValues.offers }}</div>
                                    </div>
                                    <div class="investments-item medium-bottles">
                                        <div class="investments-label">{{ $t('sell3') }}</div>
                                        <div class="bold">{{
                                                formatPrice(portfolioValues.avgPrice.toLocaleString("fi-FI", {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                }).replace(',', '.'))
                                            }}
                                        </div>
                                    </div>
                                    <div class="investments-item gain">
                                        <div class="investments-label">{{ $t('gain') }}</div>
                                        <div class="bold">{{
                                                formatPrice(portfolioValues.gain.toLocaleString("fi-FI", {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                }).replace(',', '.'))
                                            }}
                                        </div>
                                    </div>
                                </v-flex>

                                <v-data-table v-if="!mobileCheck" :headers="investmentHeaders" :items="filteredItems2"
                                              :items-per-page="4" hide-default-footer disable-sort fixed-header
                                              class="winemarket-table">
                                    <template v-slot:item="{ item }">
                                        <tr>
                                            <td class="winedetails-winesize-td">
                                                {{ item.size }}l
                                            </td>
                                            <td class="text-right">
                                                {{ item.owned }}
                                            </td>
                                            <td class="text-right">
                                                {{
                                                    formatPrice(item.averageBuyPrice.toLocaleString("fi-FI", {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    }).replace(',', '.'))
                                                }}
                                            </td>
                                            <td class="text-right">
                                                {{
                                                    formatPrice(item.gain.toLocaleString("fi-FI", {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    }).replace(',', '.'))
                                                }}
                                            </td>
                                            <td class="text-right">
                                                {{ item.bidsCases }}
                                            </td>
                                            <td class="text-right">
                                                {{ item.offersCases }}
                                            </td>
                                            <td>
                                                <button v-on:click="(event) => toggleFav(event, item)"
                                                        :class="item.isFavourite ? 'wine-star active' : 'wine-star'"></button>
                                            </td>
                                            <td class="market-btn-col half-padding-right">
                                                <button class="btn-secondary market-btn"
                                                        v-on:click="() => selectWine(item, false)">{{ $t('sell') }}
                                                </button>
                                            </td>
                                            <td class="market-btn-col half-padding-left no-padding-right">
                                                <div class="btn-secondary market-btn ga4-buy-wine"
                                                     v-on:click="() => selectWine(item, true)">{{ $t('buy') }}
                                                </div>
                                            </td>
                                        </tr>
                                    </template>

                                    <template slot="no-data">
                                        <v-alert dense class="no-orders-info">There are no orders.</v-alert>
                                    </template>
                                </v-data-table>
                            </v-flex>
                        </v-container>
                    </div>
                </div>
            </div>
            <div class="collections-container" v-else>
                <div class="collections-wrapper" v-if="wineInfo.winePictures">
                    <div class="wine-image" :style="getImgUrl(wineInfo.winePictures.bottlePicture)"></div>
                    <div class="wine-details-container">
                        <v-container class="wine-details-info">
                            <v-flex class="wine-info-wrapper">
                                <div class="wine-details-main">
                                    <div class="wine-details-head">
                                        <div class="left-col">
                                            <div v-if="wineInfo.wineName">
                                                <h2>{{ wineInfo.vintage }} {{ wineInfo.wineName }}</h2>
                                                <h3 v-if="wineInfo.isSecondLabel" class="addition-description">2-nd
                                                    label of {{ wineInfo.producerTypeName }}
                                                    {{ wineInfo.producerName }}</h3>
                                                <h3 v-else class="addition-description">{{ wineInfo.producerTypeName }}
                                                    {{ wineInfo.producerName }}</h3>
                                            </div>
                                            <div v-else>
                                                <h2>{{ wineInfo.vintage }} {{ wineInfo.producerTypeName }}
                                                    {{ wineInfo.producerName }}</h2>
                                            </div>
                                            <v-row class="second-row">
                                                <v-flex class="wine-details-region" v-if="!mobileCheck">
                                                    <div class="enprimeur" v-if="wineInfo.isEnPrimeur">
                                                        En Primeur
                                                        <div class="info-text">{{ $t('will-be-bottled') }}{{wineInfo.vintage.charAt(2)}}{{parseInt(wineInfo.vintage.charAt(3)) + 3}}</div>
                                                    </div>
                                                    <div class="head-country-el">
                                                        <div>
                                                            <img class="wine-details-img" :src="wineInfo.countryFlagUrl">
                                                        </div>
                                                        {{ wineInfo.countryName }}
                                                    </div>
                                                    <div class="head-region-el">
                                                        {{ wineInfo.regionName }}, {{ wineInfo.appellation }}
                                                    </div>
                                                    <div class="winemarket-winecolor-img"
                                                         :class="wineInfo.color == 'Red' ? 'redwine' : (wineInfo.color == 'White' ? 'whitewine' : 'champagne')"></div>
                                                    <div class="last-trade-el">
                                                        {{ wineInfo.color }}
                                                    </div>
                                                    <div class="last-trade-el last-trade-el-class">
                                                        {{ wineInfo.classification }}
                                                    </div>
                                                    <div class="last-trade-el right-side">
                                                        {{ $t('last-trade') }}: {{
                                                            !wineInfo.lastTraded ? '-' : formatDate(wineInfo.lastTraded, 'DD MMM YYYY hh:mm')
                                                        }}
                                                    </div>
                                                </v-flex>
                                                <v-flex class="wine-details-region" v-if="mobileCheck">
                                                    <div class="wine-details-img country-flag" :style="{ background: `url(${wineInfo.countryFlagUrl}) no-repeat center` }"></div>
                                                    <div style="margin-right: 10px;">{{ wineInfo.countryName }}</div>
                                                    <div class="head-region-el">{{ wineInfo.regionName }},
                                                        {{ wineInfo.appellation }}
                                                    </div>
                                                </v-flex>
                                                <v-flex class="wine-details-region" v-if="mobileCheck">
                                                    <div class="winemarket-winecolor-img"
                                                         :class="wineInfo.color == 'Red' ? 'redwine' : (wineInfo.color == 'White' ? 'whitewine' : 'champagne')"></div>
                                                    <div class="last-trade-el">{{ wineInfo.color }}</div>
                                                    <div class="last-trade-el last-trade-el-class">
                                                        {{ wineInfo.classification }}
                                                    </div>
                                                    <div class="last-trade-el">{{ $t('last-trade') }}: {{
                                                            !wineInfo.lastTraded ? '-' : formatDate(wineInfo.lastTraded, 'DD MMM YYYY hh:mm')
                                                        }}
                                                    </div>
                                                </v-flex>
                                            </v-row>
                                        </div>
                                        <div class="right-col producer">
                                            <div class="share-row" v-if="!mobileCheck">
                                                <div class="share-title">{{ $t('share') }}</div>
                                                <ShareNetwork
                                                    network="facebook"
                                                    :url="windowHref"
                                                    :title=wineNameShare
                                                    :description="wineInfo.wineShortDescription"
                                                    hashtags="wines,invest,vindome"
                                                >
                                                    <svg width="16" height="16" viewBox="0 0 26 24"
                                                         xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M25.6059 11.9991C25.6059 5.37216 19.8738 0 12.803 0C5.73207 0 0 5.37216 0 11.9991C0 17.9882 4.68186 22.9522 10.8025 23.8524V15.4676H7.55174V11.9991H10.8025V9.35553C10.8025 6.34826 12.7139 4.68714 15.6383 4.68714C17.0391 4.68714 18.5043 4.92149 18.5043 4.92149V7.87439H16.8899C15.2994 7.87439 14.8034 8.79933 14.8034 9.74824V11.9991H18.3542L17.7866 15.4676H14.8034V23.8524C20.9241 22.9522 25.6059 17.9882 25.6059 11.9991Z"
                                                            fill="black"/>
                                                    </svg>
                                                </ShareNetwork>
                                                <ShareNetwork
                                                    network="linkedin"
                                                    :url="windowHref"
                                                    :title=wineNameShare
                                                >
                                                    <svg width="16" height="16" viewBox="0 0 26 24"
                                                         xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M22.1743 20.452H18.3822V14.883C18.3822 13.555 18.3534 11.846 16.4061 11.846C14.429 11.846 14.127 13.291 14.127 14.785V20.452H10.3349V9H13.9776V10.561H14.0267C14.5357 9.661 15.7734 8.711 17.6225 8.711C21.4647 8.711 22.1753 11.081 22.1753 14.166V20.452H22.1743ZM6.05197 7.433C4.83133 7.433 3.85076 6.507 3.85076 5.368C3.85076 4.23 4.8324 3.305 6.05197 3.305C7.26835 3.305 8.25425 4.23 8.25425 5.368C8.25425 6.507 7.26728 7.433 6.05197 7.433ZM7.95336 20.452H4.15059V9H7.95336V20.452ZM24.0714 0H2.24707C1.20248 0 0.357422 0.774 0.357422 1.729V22.271C0.357422 23.227 1.20248 24 2.24707 24H24.0682C25.1117 24 25.9653 23.227 25.9653 22.271V1.729C25.9653 0.774 25.1117 0 24.0682 0H24.0714Z"
                                                            fill="black"/>
                                                    </svg>
                                                </ShareNetwork>
                                                <ShareNetwork
                                                    network="whatsapp"
                                                    :url="windowHref"
                                                    :title=wineNameShare
                                                    :description="wineInfo.wineShortDescription"
                                                >
                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                                         xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M11.6481 9.58803C11.4501 9.48869 10.4761 9.01003 10.2948 8.94336C10.1128 8.87736 9.98075 8.84469 9.84809 9.04336C9.71675 9.24136 9.33675 9.68736 9.22142 9.81936C9.10609 9.95203 8.99009 9.96803 8.79209 9.86936C8.59409 9.76936 7.95542 9.56069 7.19875 8.88603C6.61009 8.36069 6.21209 7.71203 6.09675 7.51336C5.98142 7.31536 6.08475 7.20803 6.18342 7.10936C6.27275 7.02069 6.38209 6.87803 6.48075 6.76269C6.58009 6.64669 6.61275 6.56403 6.67942 6.43136C6.74542 6.29936 6.71275 6.18403 6.66275 6.08469C6.61275 5.98536 6.21675 5.01003 6.05209 4.61336C5.89075 4.22736 5.72742 4.28003 5.60609 4.27336C5.49075 4.26803 5.35875 4.26669 5.22609 4.26669C5.09409 4.26669 4.87942 4.31603 4.69809 4.51469C4.51675 4.71269 4.00475 5.19203 4.00475 6.16736C4.00475 7.14203 4.71475 8.08403 4.81342 8.21669C4.91275 8.34869 6.21075 10.35 8.19809 11.208C8.67075 11.412 9.03942 11.534 9.32742 11.6247C9.80209 11.776 10.2341 11.7547 10.5748 11.7034C10.9554 11.6467 11.7468 11.224 11.9121 10.7614C12.0774 10.2987 12.0774 9.90203 12.0274 9.81936C11.9781 9.73669 11.8461 9.68736 11.6474 9.58803H11.6481ZM8.03342 14.5234H8.03075C6.8506 14.5235 5.69214 14.2062 4.67675 13.6047L4.43609 13.462L1.94209 14.1167L2.60742 11.6847L2.45075 11.4354C1.79105 10.3849 1.44205 9.16915 1.44409 7.92869C1.44475 4.29536 4.40142 1.33936 8.03609 1.33936C9.79609 1.33936 11.4508 2.02603 12.6948 3.27136C13.3085 3.88244 13.795 4.60918 14.1261 5.40952C14.4571 6.20987 14.6262 7.06792 14.6234 7.93403C14.6214 11.5674 11.6654 14.5234 8.03342 14.5234ZM13.6421 2.32536C12.9075 1.58598 12.0336 0.999719 11.0708 0.600561C10.108 0.201403 9.07564 -0.0027175 8.03342 2.73184e-05C3.66342 2.73184e-05 0.106753 3.55669 0.104753 7.92803C0.104753 9.32536 0.469419 10.6894 1.16342 11.8914L0.0380859 16L4.24142 14.8974C5.40381 15.5306 6.70638 15.8625 8.03009 15.8627H8.03342C12.4028 15.8627 15.9601 12.306 15.9621 7.93403C15.9653 6.89221 15.7619 5.86009 15.3637 4.89738C14.9655 3.93467 14.3803 3.06047 13.6421 2.32536Z"
                                                            fill="black"/>
                                                    </svg>
                                                </ShareNetwork>
                                                <ShareNetwork
                                                    network="viber"
                                                    :url="windowHref"
                                                    :title=wineNameShare
                                                    :description="wineInfo.wineShortDescription"
                                                >
                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                                         xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M13.4817 1.56135C13.0846 1.19332 11.4769 0.0262491 7.89822 0.0117214C7.89822 0.0117214 3.67549 -0.24493 1.60286 1.64368C0.455173 2.79137 0.0532386 4.4669 0.0096554 6.54437C-0.0339278 8.62183 -0.0871966 12.5153 3.6658 13.5709V15.1835C3.6658 15.1835 3.66581 15.8373 4.07258 15.968C4.59074 16.1327 4.89582 15.6339 5.3946 15.1012C5.66579 14.8058 6.04351 14.3748 6.32438 14.0455C7.92109 14.1947 9.53149 14.0769 11.0895 13.6969C11.6076 13.5274 14.5422 13.1545 15.0217 9.25621C15.5301 5.24171 14.7989 2.7042 13.4817 1.56135ZM13.9176 8.9705C13.5108 12.2199 11.1331 12.4233 10.6972 12.5637C9.35672 12.8941 7.97285 13.0134 6.59557 12.9172C6.59557 12.9172 4.96846 14.8542 4.45999 15.3869C4.4317 15.4203 4.39587 15.4466 4.35546 15.4634C4.31504 15.4802 4.27119 15.4872 4.22754 15.4838C4.14038 15.4596 4.11616 15.3579 4.11616 15.2077C4.11616 15.0576 4.11616 12.5298 4.11616 12.5298C0.939431 11.6436 1.12345 8.33128 1.16219 6.59763C1.20093 4.86399 1.52538 3.44027 2.4939 2.48144C4.23239 0.907602 7.82074 1.14004 7.82074 1.14004C10.8474 1.14004 12.3001 2.06498 12.6343 2.37006C13.7626 3.32889 14.3292 5.61459 13.9176 8.9705V8.9705Z"
                                                            fill="#231815"/>
                                                        <path
                                                            d="M9.37037 6.65559C9.31807 6.65565 9.26775 6.63555 9.22987 6.59948C9.192 6.56341 9.16948 6.51413 9.16699 6.46189C9.17971 6.32339 9.16245 6.18377 9.11639 6.05254C9.07033 5.92131 8.99654 5.80153 8.90005 5.70137C8.80356 5.6012 8.68663 5.52299 8.55721 5.47206C8.42779 5.42113 8.28892 5.39866 8.15005 5.4062C8.0961 5.40299 8.04564 5.37848 8.00977 5.33807C7.9739 5.29766 7.95555 5.24465 7.95876 5.19071C7.96198 5.13677 7.98648 5.08631 8.02689 5.05044C8.06731 5.01457 8.12032 4.99621 8.17426 4.99942C8.3642 4.99357 8.55326 5.02757 8.72927 5.09923C8.90527 5.17089 9.06432 5.27861 9.19616 5.41547C9.328 5.55233 9.42972 5.71529 9.49475 5.89385C9.55979 6.07241 9.5867 6.26261 9.57376 6.4522C9.57507 6.47891 9.57109 6.50563 9.56205 6.5308C9.55302 6.55598 9.5391 6.57913 9.52111 6.59892C9.50312 6.61871 9.4814 6.63476 9.4572 6.64614C9.43299 6.65753 9.40678 6.66403 9.38006 6.66527L9.37037 6.65559Z"
                                                            fill="#231815"/>
                                                        <path
                                                            d="M10.4115 7.00438C10.3848 7.00376 10.3585 6.99787 10.334 6.98706C10.3096 6.97626 10.2875 6.96074 10.2691 6.94141C10.2507 6.92207 10.2362 6.89929 10.2266 6.87436C10.217 6.84944 10.2123 6.82287 10.213 6.79616C10.2312 6.48525 10.1871 6.17383 10.0831 5.88025C9.97915 5.58667 9.81749 5.31687 9.60765 5.08673C9.14482 4.60737 8.51114 4.33057 7.84495 4.31675C7.81596 4.31862 7.78691 4.31426 7.75974 4.30397C7.73258 4.29367 7.70793 4.27767 7.68747 4.25705C7.66701 4.23643 7.6512 4.21167 7.64111 4.18442C7.63102 4.15718 7.62688 4.1281 7.62898 4.09912C7.63107 4.07015 7.63935 4.04196 7.65325 4.01645C7.66716 3.99094 7.68636 3.96871 7.70958 3.95124C7.7328 3.93378 7.75948 3.9215 7.78785 3.91521C7.81621 3.90893 7.84559 3.9088 7.87401 3.91482C8.64309 3.93577 9.3733 4.2574 9.90789 4.81069C10.3941 5.35046 10.6466 6.06092 10.6101 6.78647C10.6128 6.81412 10.6097 6.84204 10.6009 6.86841C10.5921 6.89478 10.5779 6.91902 10.5592 6.93956C10.5405 6.9601 10.5177 6.97648 10.4923 6.98765C10.4668 6.99881 10.4393 7.00452 10.4115 7.00438V7.00438Z"
                                                            fill="#231815"/>
                                                        <path
                                                            d="M11.4721 7.42082C11.4181 7.42082 11.3664 7.39939 11.3282 7.36125C11.2901 7.3231 11.2687 7.27137 11.2687 7.21743C11.2971 6.68418 11.215 6.15081 11.0275 5.6508C10.84 5.15079 10.5511 4.69494 10.1791 4.31188C9.82476 3.96579 9.40503 3.69376 8.9444 3.51167C8.48378 3.32958 7.9915 3.24109 7.4963 3.25136C7.44235 3.25136 7.39062 3.22993 7.35248 3.19178C7.31433 3.15364 7.29291 3.10191 7.29291 3.04797C7.29291 2.99403 7.31433 2.9423 7.35248 2.90415C7.39062 2.86601 7.44235 2.84458 7.4963 2.84458C8.04351 2.83537 8.58714 2.93461 9.0958 3.13658C9.60447 3.33855 10.0681 3.63925 10.46 4.02132C10.8671 4.44076 11.1844 4.93878 11.3925 5.48498C11.6007 6.03117 11.6953 6.61407 11.6706 7.19806C11.6706 7.25201 11.6492 7.30374 11.611 7.34188C11.5729 7.38002 11.5212 7.40145 11.4672 7.40145L11.4721 7.42082Z"
                                                            fill="#231815"/>
                                                        <path
                                                            d="M8.20329 9.16411C8.28355 9.17009 8.36414 9.15846 8.43943 9.13002C8.51471 9.10158 8.58287 9.05702 8.63912 8.99946L8.93936 8.62174C9.04216 8.50861 9.1816 8.43541 9.33309 8.41504C9.48458 8.39466 9.63841 8.42842 9.76745 8.51036C10.0244 8.65856 10.2733 8.82021 10.5132 8.99462C10.7408 9.16411 11.2009 9.54668 11.2009 9.55152C11.3092 9.63917 11.3815 9.76369 11.4038 9.90127C11.4262 10.0389 11.397 10.1798 11.3219 10.2973V10.2973C11.1571 10.5835 10.9479 10.8418 10.7021 11.0624V11.0624C10.5247 11.2235 10.3043 11.3295 10.0677 11.3675C10.0372 11.3727 10.0061 11.3727 9.97567 11.3675C9.8854 11.3688 9.79548 11.3558 9.70933 11.3287V11.3287C9.10577 11.1201 8.52492 10.8507 7.97569 10.5249C7.46449 10.2444 6.97843 9.92037 6.52292 9.55636C6.29408 9.3753 6.0758 9.18128 5.86917 8.97525V8.97525H5.84495C5.64015 8.76577 5.4462 8.54595 5.26385 8.31666C4.90146 7.85996 4.57752 7.37404 4.29533 6.86389C3.96935 6.3154 3.70155 5.73437 3.4963 5.13024C3.46769 5.04268 3.45299 4.95117 3.45272 4.85906C3.4498 4.82846 3.4498 4.79765 3.45272 4.76705C3.48997 4.53166 3.59613 4.3126 3.7578 4.13751V4.13751C3.94408 3.85542 4.17464 3.60524 4.44061 3.3966V3.3966C4.55879 3.32119 4.70056 3.29185 4.83896 3.31418C4.97736 3.3365 5.10273 3.40892 5.19121 3.51766C5.19121 3.51766 5.57861 4.00192 5.74326 4.20531C5.90791 4.40869 6.1113 4.76221 6.22752 4.95107C6.30737 5.08195 6.33943 5.23644 6.31825 5.38829C6.29706 5.54014 6.22393 5.67996 6.1113 5.78398L5.73358 6.07938C5.67591 6.13657 5.63132 6.20558 5.6029 6.28165C5.57447 6.35773 5.56288 6.43907 5.56893 6.52006C5.75345 7.14512 6.091 7.71428 6.551 8.17597C7.011 8.63766 7.57891 8.97729 8.20329 9.16411Z"
                                                            fill="#231815"/>
                                                    </svg>
                                                </ShareNetwork>
                                                <ShareNetwork
                                                    network="twitter"
                                                    :url="windowHref"
                                                    :title=wineNameShare
                                                    :description="wineInfo.wineShortDescription"
                                                    hashtags="wines,invest,vindome"
                                                >
                                                    <svg width="16" height="13" viewBox="0 0 26 20"
                                                         xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M25.5959 2.56897C24.6516 2.95797 23.6433 3.22297 22.5816 3.34397C23.6636 2.73297 24.4958 1.76997 24.8896 0.620972C23.8748 1.17597 22.7502 1.57997 21.5531 1.80497C20.597 0.845972 19.2345 0.245972 17.7215 0.245972C14.8225 0.245972 12.4719 2.44897 12.4719 5.16297C12.4719 5.55297 12.5199 5.92797 12.6074 6.28697C8.24337 6.09397 4.37551 4.12997 1.78698 1.16097C1.33137 1.88297 1.07636 2.72197 1.07636 3.63597C1.07636 5.34597 2.00465 6.84897 3.41095 7.73197C2.54988 7.70597 1.74003 7.48397 1.03368 7.11597V7.17697C1.03368 9.56197 2.84011 11.551 5.24405 12.004C4.80338 12.115 4.33817 12.175 3.86122 12.175C3.52618 12.175 3.20502 12.145 2.88385 12.089C3.55713 14.042 5.49265 15.466 7.7963 15.506C6.00375 16.825 3.73211 17.611 1.28549 17.611C0.869365 17.611 0.454304 17.588 0.0371094 17.544C2.37276 18.938 5.12454 19.753 8.10039 19.753C17.761 19.753 23.0373 12.257 23.0373 5.76697C23.0373 5.55797 23.0373 5.34697 23.0212 5.13697C24.0466 4.44797 24.9418 3.57697 25.6461 2.58897L25.5959 2.56897Z"
                                                            fill="black"/>
                                                    </svg>
                                                </ShareNetwork>
                                                <ShareNetwork
                                                    network="email"
                                                    :url="windowHref"
                                                    :title="wineNameShare"
                                                    :description="wineInfo.wineShortDescription"
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" height="24"
                                                         viewBox="0 0 24 24" width="24">
                                                        <path d="M0 0h24v24H0z" fill="none"/>
                                                        <path
                                                            d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                                                    </svg>
                                                </ShareNetwork>
                                            </div>
                                            <div class="back-order" v-on:click="$router.go(-1)">
                                                <div>{{ $t('back') }}</div>
                                                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24"
                                                     width="24">
                                                    <path d="M0 0h24v24H0z" fill="none"/>
                                                    <path
                                                        d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="share-row-mobile" v-if="mobileCheck">
                                        <div class="share-title">{{ $t('share') }}</div>
                                        <ShareNetwork
                                            network="facebook"
                                            :url="windowHref"
                                            :title=wineNameShare
                                            :description="wineInfo.wineShortDescription"
                                            hashtags="wines,invest,vindome"
                                        >
                                            <svg width="16" height="16" viewBox="0 0 26 24"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M25.6059 11.9991C25.6059 5.37216 19.8738 0 12.803 0C5.73207 0 0 5.37216 0 11.9991C0 17.9882 4.68186 22.9522 10.8025 23.8524V15.4676H7.55174V11.9991H10.8025V9.35553C10.8025 6.34826 12.7139 4.68714 15.6383 4.68714C17.0391 4.68714 18.5043 4.92149 18.5043 4.92149V7.87439H16.8899C15.2994 7.87439 14.8034 8.79933 14.8034 9.74824V11.9991H18.3542L17.7866 15.4676H14.8034V23.8524C20.9241 22.9522 25.6059 17.9882 25.6059 11.9991Z"
                                                    fill="black"/>
                                            </svg>
                                        </ShareNetwork>
                                        <ShareNetwork
                                            network="linkedin"
                                            :url="windowHref"
                                            :title=wineNameShare
                                        >
                                            <svg width="16" height="16" viewBox="0 0 26 24"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M22.1743 20.452H18.3822V14.883C18.3822 13.555 18.3534 11.846 16.4061 11.846C14.429 11.846 14.127 13.291 14.127 14.785V20.452H10.3349V9H13.9776V10.561H14.0267C14.5357 9.661 15.7734 8.711 17.6225 8.711C21.4647 8.711 22.1753 11.081 22.1753 14.166V20.452H22.1743ZM6.05197 7.433C4.83133 7.433 3.85076 6.507 3.85076 5.368C3.85076 4.23 4.8324 3.305 6.05197 3.305C7.26835 3.305 8.25425 4.23 8.25425 5.368C8.25425 6.507 7.26728 7.433 6.05197 7.433ZM7.95336 20.452H4.15059V9H7.95336V20.452ZM24.0714 0H2.24707C1.20248 0 0.357422 0.774 0.357422 1.729V22.271C0.357422 23.227 1.20248 24 2.24707 24H24.0682C25.1117 24 25.9653 23.227 25.9653 22.271V1.729C25.9653 0.774 25.1117 0 24.0682 0H24.0714Z"
                                                    fill="black"/>
                                            </svg>
                                        </ShareNetwork>
                                        <ShareNetwork
                                            network="whatsapp"
                                            :url="windowHref"
                                            :title=wineNameShare
                                            :description="wineInfo.wineShortDescription"
                                        >
                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M11.6481 9.58803C11.4501 9.48869 10.4761 9.01003 10.2948 8.94336C10.1128 8.87736 9.98075 8.84469 9.84809 9.04336C9.71675 9.24136 9.33675 9.68736 9.22142 9.81936C9.10609 9.95203 8.99009 9.96803 8.79209 9.86936C8.59409 9.76936 7.95542 9.56069 7.19875 8.88603C6.61009 8.36069 6.21209 7.71203 6.09675 7.51336C5.98142 7.31536 6.08475 7.20803 6.18342 7.10936C6.27275 7.02069 6.38209 6.87803 6.48075 6.76269C6.58009 6.64669 6.61275 6.56403 6.67942 6.43136C6.74542 6.29936 6.71275 6.18403 6.66275 6.08469C6.61275 5.98536 6.21675 5.01003 6.05209 4.61336C5.89075 4.22736 5.72742 4.28003 5.60609 4.27336C5.49075 4.26803 5.35875 4.26669 5.22609 4.26669C5.09409 4.26669 4.87942 4.31603 4.69809 4.51469C4.51675 4.71269 4.00475 5.19203 4.00475 6.16736C4.00475 7.14203 4.71475 8.08403 4.81342 8.21669C4.91275 8.34869 6.21075 10.35 8.19809 11.208C8.67075 11.412 9.03942 11.534 9.32742 11.6247C9.80209 11.776 10.2341 11.7547 10.5748 11.7034C10.9554 11.6467 11.7468 11.224 11.9121 10.7614C12.0774 10.2987 12.0774 9.90203 12.0274 9.81936C11.9781 9.73669 11.8461 9.68736 11.6474 9.58803H11.6481ZM8.03342 14.5234H8.03075C6.8506 14.5235 5.69214 14.2062 4.67675 13.6047L4.43609 13.462L1.94209 14.1167L2.60742 11.6847L2.45075 11.4354C1.79105 10.3849 1.44205 9.16915 1.44409 7.92869C1.44475 4.29536 4.40142 1.33936 8.03609 1.33936C9.79609 1.33936 11.4508 2.02603 12.6948 3.27136C13.3085 3.88244 13.795 4.60918 14.1261 5.40952C14.4571 6.20987 14.6262 7.06792 14.6234 7.93403C14.6214 11.5674 11.6654 14.5234 8.03342 14.5234ZM13.6421 2.32536C12.9075 1.58598 12.0336 0.999719 11.0708 0.600561C10.108 0.201403 9.07564 -0.0027175 8.03342 2.73184e-05C3.66342 2.73184e-05 0.106753 3.55669 0.104753 7.92803C0.104753 9.32536 0.469419 10.6894 1.16342 11.8914L0.0380859 16L4.24142 14.8974C5.40381 15.5306 6.70638 15.8625 8.03009 15.8627H8.03342C12.4028 15.8627 15.9601 12.306 15.9621 7.93403C15.9653 6.89221 15.7619 5.86009 15.3637 4.89738C14.9655 3.93467 14.3803 3.06047 13.6421 2.32536Z"
                                                    fill="black"/>
                                            </svg>
                                        </ShareNetwork>
                                        <ShareNetwork
                                            network="viber"
                                            :url="windowHref"
                                            :title=wineNameShare
                                            :description="wineInfo.wineShortDescription"
                                        >
                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M13.4817 1.56135C13.0846 1.19332 11.4769 0.0262491 7.89822 0.0117214C7.89822 0.0117214 3.67549 -0.24493 1.60286 1.64368C0.455173 2.79137 0.0532386 4.4669 0.0096554 6.54437C-0.0339278 8.62183 -0.0871966 12.5153 3.6658 13.5709V15.1835C3.6658 15.1835 3.66581 15.8373 4.07258 15.968C4.59074 16.1327 4.89582 15.6339 5.3946 15.1012C5.66579 14.8058 6.04351 14.3748 6.32438 14.0455C7.92109 14.1947 9.53149 14.0769 11.0895 13.6969C11.6076 13.5274 14.5422 13.1545 15.0217 9.25621C15.5301 5.24171 14.7989 2.7042 13.4817 1.56135ZM13.9176 8.9705C13.5108 12.2199 11.1331 12.4233 10.6972 12.5637C9.35672 12.8941 7.97285 13.0134 6.59557 12.9172C6.59557 12.9172 4.96846 14.8542 4.45999 15.3869C4.4317 15.4203 4.39587 15.4466 4.35546 15.4634C4.31504 15.4802 4.27119 15.4872 4.22754 15.4838C4.14038 15.4596 4.11616 15.3579 4.11616 15.2077C4.11616 15.0576 4.11616 12.5298 4.11616 12.5298C0.939431 11.6436 1.12345 8.33128 1.16219 6.59763C1.20093 4.86399 1.52538 3.44027 2.4939 2.48144C4.23239 0.907602 7.82074 1.14004 7.82074 1.14004C10.8474 1.14004 12.3001 2.06498 12.6343 2.37006C13.7626 3.32889 14.3292 5.61459 13.9176 8.9705V8.9705Z"
                                                    fill="#231815"/>
                                                <path
                                                    d="M9.37037 6.65559C9.31807 6.65565 9.26775 6.63555 9.22987 6.59948C9.192 6.56341 9.16948 6.51413 9.16699 6.46189C9.17971 6.32339 9.16245 6.18377 9.11639 6.05254C9.07033 5.92131 8.99654 5.80153 8.90005 5.70137C8.80356 5.6012 8.68663 5.52299 8.55721 5.47206C8.42779 5.42113 8.28892 5.39866 8.15005 5.4062C8.0961 5.40299 8.04564 5.37848 8.00977 5.33807C7.9739 5.29766 7.95555 5.24465 7.95876 5.19071C7.96198 5.13677 7.98648 5.08631 8.02689 5.05044C8.06731 5.01457 8.12032 4.99621 8.17426 4.99942C8.3642 4.99357 8.55326 5.02757 8.72927 5.09923C8.90527 5.17089 9.06432 5.27861 9.19616 5.41547C9.328 5.55233 9.42972 5.71529 9.49475 5.89385C9.55979 6.07241 9.5867 6.26261 9.57376 6.4522C9.57507 6.47891 9.57109 6.50563 9.56205 6.5308C9.55302 6.55598 9.5391 6.57913 9.52111 6.59892C9.50312 6.61871 9.4814 6.63476 9.4572 6.64614C9.43299 6.65753 9.40678 6.66403 9.38006 6.66527L9.37037 6.65559Z"
                                                    fill="#231815"/>
                                                <path
                                                    d="M10.4115 7.00438C10.3848 7.00376 10.3585 6.99787 10.334 6.98706C10.3096 6.97626 10.2875 6.96074 10.2691 6.94141C10.2507 6.92207 10.2362 6.89929 10.2266 6.87436C10.217 6.84944 10.2123 6.82287 10.213 6.79616C10.2312 6.48525 10.1871 6.17383 10.0831 5.88025C9.97915 5.58667 9.81749 5.31687 9.60765 5.08673C9.14482 4.60737 8.51114 4.33057 7.84495 4.31675C7.81596 4.31862 7.78691 4.31426 7.75974 4.30397C7.73258 4.29367 7.70793 4.27767 7.68747 4.25705C7.66701 4.23643 7.6512 4.21167 7.64111 4.18442C7.63102 4.15718 7.62688 4.1281 7.62898 4.09912C7.63107 4.07015 7.63935 4.04196 7.65325 4.01645C7.66716 3.99094 7.68636 3.96871 7.70958 3.95124C7.7328 3.93378 7.75948 3.9215 7.78785 3.91521C7.81621 3.90893 7.84559 3.9088 7.87401 3.91482C8.64309 3.93577 9.3733 4.2574 9.90789 4.81069C10.3941 5.35046 10.6466 6.06092 10.6101 6.78647C10.6128 6.81412 10.6097 6.84204 10.6009 6.86841C10.5921 6.89478 10.5779 6.91902 10.5592 6.93956C10.5405 6.9601 10.5177 6.97648 10.4923 6.98765C10.4668 6.99881 10.4393 7.00452 10.4115 7.00438V7.00438Z"
                                                    fill="#231815"/>
                                                <path
                                                    d="M11.4721 7.42082C11.4181 7.42082 11.3664 7.39939 11.3282 7.36125C11.2901 7.3231 11.2687 7.27137 11.2687 7.21743C11.2971 6.68418 11.215 6.15081 11.0275 5.6508C10.84 5.15079 10.5511 4.69494 10.1791 4.31188C9.82476 3.96579 9.40503 3.69376 8.9444 3.51167C8.48378 3.32958 7.9915 3.24109 7.4963 3.25136C7.44235 3.25136 7.39062 3.22993 7.35248 3.19178C7.31433 3.15364 7.29291 3.10191 7.29291 3.04797C7.29291 2.99403 7.31433 2.9423 7.35248 2.90415C7.39062 2.86601 7.44235 2.84458 7.4963 2.84458C8.04351 2.83537 8.58714 2.93461 9.0958 3.13658C9.60447 3.33855 10.0681 3.63925 10.46 4.02132C10.8671 4.44076 11.1844 4.93878 11.3925 5.48498C11.6007 6.03117 11.6953 6.61407 11.6706 7.19806C11.6706 7.25201 11.6492 7.30374 11.611 7.34188C11.5729 7.38002 11.5212 7.40145 11.4672 7.40145L11.4721 7.42082Z"
                                                    fill="#231815"/>
                                                <path
                                                    d="M8.20329 9.16411C8.28355 9.17009 8.36414 9.15846 8.43943 9.13002C8.51471 9.10158 8.58287 9.05702 8.63912 8.99946L8.93936 8.62174C9.04216 8.50861 9.1816 8.43541 9.33309 8.41504C9.48458 8.39466 9.63841 8.42842 9.76745 8.51036C10.0244 8.65856 10.2733 8.82021 10.5132 8.99462C10.7408 9.16411 11.2009 9.54668 11.2009 9.55152C11.3092 9.63917 11.3815 9.76369 11.4038 9.90127C11.4262 10.0389 11.397 10.1798 11.3219 10.2973V10.2973C11.1571 10.5835 10.9479 10.8418 10.7021 11.0624V11.0624C10.5247 11.2235 10.3043 11.3295 10.0677 11.3675C10.0372 11.3727 10.0061 11.3727 9.97567 11.3675C9.8854 11.3688 9.79548 11.3558 9.70933 11.3287V11.3287C9.10577 11.1201 8.52492 10.8507 7.97569 10.5249C7.46449 10.2444 6.97843 9.92037 6.52292 9.55636C6.29408 9.3753 6.0758 9.18128 5.86917 8.97525V8.97525H5.84495C5.64015 8.76577 5.4462 8.54595 5.26385 8.31666C4.90146 7.85996 4.57752 7.37404 4.29533 6.86389C3.96935 6.3154 3.70155 5.73437 3.4963 5.13024C3.46769 5.04268 3.45299 4.95117 3.45272 4.85906C3.4498 4.82846 3.4498 4.79765 3.45272 4.76705C3.48997 4.53166 3.59613 4.3126 3.7578 4.13751V4.13751C3.94408 3.85542 4.17464 3.60524 4.44061 3.3966V3.3966C4.55879 3.32119 4.70056 3.29185 4.83896 3.31418C4.97736 3.3365 5.10273 3.40892 5.19121 3.51766C5.19121 3.51766 5.57861 4.00192 5.74326 4.20531C5.90791 4.40869 6.1113 4.76221 6.22752 4.95107C6.30737 5.08195 6.33943 5.23644 6.31825 5.38829C6.29706 5.54014 6.22393 5.67996 6.1113 5.78398L5.73358 6.07938C5.67591 6.13657 5.63132 6.20558 5.6029 6.28165C5.57447 6.35773 5.56288 6.43907 5.56893 6.52006C5.75345 7.14512 6.091 7.71428 6.551 8.17597C7.011 8.63766 7.57891 8.97729 8.20329 9.16411Z"
                                                    fill="#231815"/>
                                            </svg>
                                        </ShareNetwork>
                                        <ShareNetwork
                                            network="twitter"
                                            :url="windowHref"
                                            :title=wineNameShare
                                            :description="wineInfo.wineShortDescription"
                                            hashtags="wines,invest,vindome"
                                        >
                                            <svg width="16" height="13" viewBox="0 0 26 20"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M25.5959 2.56897C24.6516 2.95797 23.6433 3.22297 22.5816 3.34397C23.6636 2.73297 24.4958 1.76997 24.8896 0.620972C23.8748 1.17597 22.7502 1.57997 21.5531 1.80497C20.597 0.845972 19.2345 0.245972 17.7215 0.245972C14.8225 0.245972 12.4719 2.44897 12.4719 5.16297C12.4719 5.55297 12.5199 5.92797 12.6074 6.28697C8.24337 6.09397 4.37551 4.12997 1.78698 1.16097C1.33137 1.88297 1.07636 2.72197 1.07636 3.63597C1.07636 5.34597 2.00465 6.84897 3.41095 7.73197C2.54988 7.70597 1.74003 7.48397 1.03368 7.11597V7.17697C1.03368 9.56197 2.84011 11.551 5.24405 12.004C4.80338 12.115 4.33817 12.175 3.86122 12.175C3.52618 12.175 3.20502 12.145 2.88385 12.089C3.55713 14.042 5.49265 15.466 7.7963 15.506C6.00375 16.825 3.73211 17.611 1.28549 17.611C0.869365 17.611 0.454304 17.588 0.0371094 17.544C2.37276 18.938 5.12454 19.753 8.10039 19.753C17.761 19.753 23.0373 12.257 23.0373 5.76697C23.0373 5.55797 23.0373 5.34697 23.0212 5.13697C24.0466 4.44797 24.9418 3.57697 25.6461 2.58897L25.5959 2.56897Z"
                                                    fill="black"/>
                                            </svg>
                                        </ShareNetwork>
                                        <ShareNetwork
                                            network="email"
                                            :url="windowHref"
                                            :title="wineNameShare"
                                            :description="wineInfo.wineShortDescription"
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24"
                                                 width="24">
                                                <path d="M0 0h24v24H0z" fill="none"/>
                                                <path
                                                    d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                                            </svg>
                                        </ShareNetwork>
                                    </div>

                                    <div class="lang-wrapper" v-if="wineInfo.wineShortDescription != ''">
                                        <span>{{ $t('translate-to') }}:</span>
                                        <div class="lang-item" v-on:click="translateTo('en')"
                                             style="align-items: center">
                                            <img class="wine-image2 wine-image3" src="../../../../assets/home/en.png"/>
                                        </div>
                                        <div class="lang-item" v-on:click="translateTo('it')"
                                             style="align-items: center">
                                            <img class="wine-image2" src="../../../../assets/home/it.png"/>
                                        </div>
                                        <div class="lang-item" v-on:click="translateTo('fr')"
                                             style="align-items: center">
                                            <img class="wine-image2" src="../../../../assets/home/fr.png"/>
                                        </div>
                                        <div class="lang-item" v-on:click="translateTo('de')"
                                             style="align-items: center">
                                            <img class="wine-image2" src="../../../../assets/home/de.png"/>
                                        </div>
                                        <div class="lang-item" v-on:click="translateTo('ru')"
                                             style="align-items: center">
                                            <img class="wine-image2" src="../../../../assets/home/ru.png"/>
                                        </div>
                                    </div>
                                    <v-flex class="wine-details-shortdesc" v-if="wineInfo.wineShortDescription != ''"
                                            v-html="desc"></v-flex>
                                    <v-flex class="wine-details-shortdesc" v-else>No description available for this
                                        wine.
                                    </v-flex>

                                    <div class="sat-container" v-if="wineInfo.wineGrapes">
                                        <div class="rating-title" v-if="wineInfo.wineGrapes.grapes[wineInfo.vintage]">
                                            {{ $t('grape') }}
                                        </div>
                                        <div class="grapes-wrapper" v-if="wineInfo.wineGrapes.grapes[wineInfo.vintage]">
                                            <div class="grape-item"
                                                 v-for="(grapeItem, index) in wineInfo.wineGrapes.grapes[wineInfo.vintage]"
                                                 :key="index">
                                                <div class="grape-percent">{{ grapeItem.percentage }}<span
                                                    class="grape-percent-span">%</span></div>
                                                <div class="grape-title">{{ grapeItem.grape }}</div>
                                            </div>
                                        </div>

                                        <div class="saturnalia-btn" v-on:click="showSaturnalia">{{
                                                $t('saturnalia1')
                                            }}
                                        </div>
                                    </div>

                                    <div class="rating-title">{{ $t('ratings') }}</div>
                                    <v-layout>
                                        <v-flex class="rating-item">
                                            <div class="rating-value">{{ wineInfo.ratings.wineAdvocate || '-' }}<span>/100</span>
                                            </div>
                                            <div class="rating-logo rating-logo1"></div>
                                        </v-flex>
                                        <v-flex class="rating-item">
                                            <div class="rating-value">
                                                {{ wineInfo.ratings.nealMartin || '-' }}<span>/100</span></div>
                                            <div class="rating-logo rating-logo2"></div>
                                        </v-flex>
                                        <v-flex class="rating-item">
                                            <div class="rating-value">{{ wineInfo.ratings.wineSpectator || '-' }}<span>/100</span>
                                            </div>
                                            <div class="rating-logo rating-logo3"></div>
                                        </v-flex>
                                        <v-flex class="rating-item">
                                            <div class="rating-value">{{ wineInfo.ratings.jancisRobinson || '-' }}<span>/20</span>
                                            </div>
                                            <div class="rating-logo rating-logo4"></div>
                                        </v-flex>
                                        <v-flex class="rating-item">
                                            <div class="rating-value">{{ wineInfo.ratings.antonioGalloni || '-' }}<span>/100</span>
                                            </div>
                                            <div class="rating-logo rating-logo5"></div>
                                        </v-flex>
                                    </v-layout>
                                </div>

                                <h4 class="not-logged-h5">{{ $t('all-case-sizes') }}</h4>
                                <v-data-table v-if="!mobileCheck" :headers="headersNotLogged"
                                              :items="wineInfo.availableWineCases" :items-per-page="4"
                                              hide-default-footer disable-sort fixed-header class="winemarket-table">
                                    <template v-slot:item="{ item }">
                                        <tr>
                                            <td class="winedetails-winesize-td">
                                                {{ item.caseSize }}l
                                                <div>&nbsp;</div>
                                            </td>
                                            <td class="text-right">
                                                {{
                                                    formatPrice(item.bestSell.toLocaleString("fi-FI", {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    }).replace(',', '.'))
                                                }}
                                                <div>&nbsp;</div>
                                            </td>
                                            <td class="text-right">
                                                {{
                                                    formatPrice(item.bestBuy.toLocaleString("fi-FI", {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    }).replace(',', '.'))
                                                }}
                                                <div>&nbsp;</div>
                                            </td>
                                            <td class="text-right">
                                                {{
                                                    item.lastTrade == 0 ? '-' : formatPrice(item.lastTrade.toLocaleString("fi-FI", {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    }).replace(',', '.'))
                                                }}
                                                <div class="winemarket-change positive">
                                                    0.00%
                                                    <div></div>
                                                </div>
                                            </td>
                                            <td>
                                                <button class="wine-star" v-on:click="showLoginModal"></button>
                                            </td>
                                            <td class="market-btn-col half-padding-right">
                                                <button class="btn-secondary market-btn" disabled="true"
                                                        v-on:click="showLoginModal">{{ $t('sell') }}
                                                </button>
                                            </td>
                                            <td class="market-btn-col half-padding-left no-padding-right">
                                                <div class="btn-secondary market-btn" v-on:click="showLoginModal">
                                                    {{ $t('buy') }}
                                                </div>
                                            </td>
                                        </tr>
                                    </template>

                                    <template slot="no-data">
                                        <v-alert dense type="info" class="no-orders-info">There are no orders.</v-alert>
                                    </template>
                                </v-data-table>
                                <div class="mobile-all-cases-wrapper" v-else>
                                    <div class="mobile-wines-header">
                                        <div>{{ $t('case-size') }}</div>
                                        <div>Favourites</div>
                                        <div>Best buy</div>
                                        <div>Best sell</div>
                                        <div>Last trade</div>
                                        <div>Last trade %</div>
                                    </div>
                                    <div class="mobile-wines-body">
                                        <div class="mobile-wines-row"
                                             v-for="(item, index) in wineInfo.availableWineCases" :key="index">
                                            <div class="mobile-wines-div wineitem-td">
                                                {{ item.caseSize }}l
                                            </div>
                                            <div class="mobile-wines-div wineitem-td">
                                                <button v-on:click="(event) => toggleFav(event, item)"
                                                        :class="item.isFavourite ? 'wine-star active' : 'wine-star'"></button>
                                            </div>
                                            <div class="mobile-wines-div wineitem-td">
                                                {{
                                                    formatPrice(item.bestSell.toLocaleString("fi-FI", {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    }).replace(',', '.'))
                                                }}
                                            </div>
                                            <div class="mobile-wines-div wineitem-td">
                                                {{
                                                    formatPrice(item.bestBuy.toLocaleString("fi-FI", {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    }).replace(',', '.'))
                                                }}
                                            </div>
                                            <div class="mobile-wines-div wineitem-td">
                                                {{
                                                    item.lastTrade == null ? '-' : formatPrice(item.lastTrade.toLocaleString("fi-FI", {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    }).replace(',', '.'))
                                                }}
                                            </div>
                                            <div class="mobile-wines-div wineitem-td">
                                                <div class="winemarket-change"
                                                     :class="item.change > -1 ? 'positive' : (item.change == null ? '' : 'negative')">
                                                    {{ item.change == null ? '0.00%' : `${item.change.toFixed(2)}%` }}
                                                    <div></div>
                                                </div>
                                            </div>
                                            <div class="mobile-wines-div market-btn-col half-padding-right">
                                                <button class="btn-secondary market-btn" v-on:click="showLoginModal"
                                                        disabled>{{ $t('sell') }}
                                                </button>
                                            </div>
                                            <div class="mobile-wines-div market-btn-col">
                                                <div class="btn-secondary market-btn" v-on:click="showLoginModal">
                                                    {{ $t('buy') }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </v-flex>
                        </v-container>
                    </div>
                </div>
            </div>
        </v-layout>

        <v-dialog v-model="saturnaliaMapDialog" max-width="620px">
            <v-card class="saturnalia-modal">
                <div class="saturnalia-title">{{ $t('saturnalia1') }}</div>
                <div class="saturnalia-map-wrapper">
                    <iframe frameBorder="0" id="output-frame-id" class="sat-iframe" :src="iframeUrl"></iframe>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import Vue from 'vue';
import VueSocialSharing from 'vue-social-sharing'
import {mapGetters} from 'vuex';
import {AMarket, APortfolio, AUser, AWines} from '@/store/actions'
import {GWines, GPortfolio, GMarket} from "@/store/getters";
import Orders from "../../../../components/WineDetailsOrders";
import DomInfo from '../../../../components/DomInfo';
import moment from 'moment';
import axios from "axios";
import {GCommon} from "@/store/getters";
Vue.use(VueSocialSharing)

export default {
    name: "Winedetails",
    head: {
        title: 'Wine details | Fine Wine Trading App',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
            }
        ],
        bodyAttrs: {
            class: 'wine-details-page'
        }
    },
    components: {
        Orders,
        DomInfo
    },
    data() {
        return {
            iframeUrl: '',
            saturnaliaMapDialog: false,
            windowHref: '',
            actionTypes: ['Buy', 'Sell'],
            investmentHeaders: [
                {text: this.$i18n.t('case-size'), align: 'left', class: 'wine-th'},
                {text: 'Owned', value: 'owned', align: 'right'},
                {text: 'Avg. buy price', value: 'units', align: 'right'},
                {text: 'Gain', value: 'price', align: 'right'},
                {text: 'My bids', value: 'profit', align: 'right'},
                {text: 'My Offers', align: 'right'},
                {text: 'Favourites', value: 'isFavourite', align: 'center'},
                {text: '', value: 'buyWine'},
                {text: '', value: 'sellWine'}
            ],
            headers: [
                {text: this.$i18n.t('case-size'), align: 'left', value: 'size', class: 'wine-th'},
                {text: 'Best buy', align: 'right', value: 'price'},
                {text: 'Best sell', align: 'right', value: 'units'},
                {text: 'Last trade', align: 'right', value: 'lastTradePrice'},
                {text: 'Favourites', align: 'center', value: 'isFavourite'},
                {text: '', value: 'buyWine'},
                {text: '', value: 'sellWine'}
            ],
            headersNotLogged: [
                {text: this.$i18n.t('case-size'), align: 'left', value: 'size', class: 'wine-th'},
                {text: 'Best buy', align: 'right', value: 'price'},
                {text: 'Best sell', align: 'right', value: 'units'},
                {text: 'Last trade', align: 'right', value: 'lastTradePrice'},
                {text: 'Favourites', align: 'center', value: 'isFavourite'},
                {text: '', value: 'buyWine'},
                {text: '', value: 'sellWine'}
            ],
            allSizesList: [],
            isLogged: false,
            desc: ''
        }
    },
    computed: {
        ...mapGetters({
            wineInfo: GWines.GET_SELECTED_WINE_INFO,
            wineItems: GMarket.GET_WINES,
            favWinesList: GWines.GET_FAVOURITE_WINES,
            portfolioSummary: GPortfolio.GET_PORTFOLIO_SUMMARY,
            mobileCheck: GCommon.GET_MOBILE_VERSION
        }),
        wineNameShare() {
            if (this.isLogged) {
                return `${this.wineInfo.wine.vintage} ${this.wineInfo.wine.otherProducer}, ${this.wineInfo.wine.producer}`
            } else {
                return `${this.wineInfo.vintage} ${this.wineInfo.producer2}, ${this.wineInfo.producer1}`
            }
        },
        filteredItems() {
            let winesTbl = this;
            let wineCases = [];
            this.wineItems.forEach(item => {
                let isWineInFavourites = false;
                if (item.wineId === parseInt(winesTbl.wineId)) {
                    this.favWinesList.forEach(wine => {
                        if (item.wineId === wine.wineId) {
                            isWineInFavourites = true;
                        }
                    });
                    wineCases.push(Object.assign({isFavourite: isWineInFavourites}, item))
                }
            });
            return wineCases
        },
        filteredItems2() {
            let winesTbl = this;
            let wineCases = [];
            this.portfolioSummary.forEach(item => {
                let isWineInFavourites = false;
                if (item.wineId === parseInt(winesTbl.wineId)) {
                    this.favWinesList.forEach(wine => {
                        if (item.wineId === wine.wineId) {
                            isWineInFavourites = true;
                        }
                    });
                    wineCases.push(Object.assign({isFavourite: isWineInFavourites}, item))
                }
            });
            return wineCases
        },
        portfolioValues() {
            let winePortfolio = {
                cases: 0,
                offers: 0,
                avgPrice: 0,
                gain: 0
            };
            let currentWineId = this.wineId;
            this.portfolioSummary.forEach(el => {
                if (el.wineId === parseInt(currentWineId)) {
                    winePortfolio.cases = el.owned;
                    winePortfolio.offers = el.offersCases;
                    winePortfolio.avgPrice = el.averageBuyPrice;
                    winePortfolio.gain = el.gain;
                }
            });
            return winePortfolio
        }
    },
    methods: {
        showLoginModal() {
            this.$nuxt.$emit("showLoginModal", '');
        },
        formatPrice(price) {
            return `€ ${price}`
        },
        async translateTo(lang) {
            let _ctrl = this;

            if (lang === 'en') {
                this.desc = this.isLogged ? this.wineInfo.wine.shortDescription : this.wineInfo.wineShortDescription
            } else {
                axios.post('https://translation.googleapis.com/language/translate/v2?key=AIzaSyB1DbQFCELGu1CJRNNlrrY1LKiS_MKiPTw', {
                    q: _ctrl.isLogged ? _ctrl.wineInfo.wine.shortDescription : _ctrl.wineInfo.wineShortDescription,
                    target: lang,
                    format: "text",
                    source: "en"
                }).then(function (response) {
                    _ctrl.desc = response.data.data.translations[0].translatedText
                })
            }
        },
        goToLogin() {
            localStorage.setItem('login_path', window.location.pathname);
            this.$router.push({path: '/login'});
        },
        goToRegister() {
            this.$router.push({path: '/register'});
        },
        formatDate(date, format) {
            return moment(date).locale(this.$i18n.locale).format(format == null ? 'DD-MM-YYYY HH:mm' : format)
        },
        selectWine(item, isBuy) {
            this.$store.dispatch(AWines.SELECT_WINE_ID, {
                wineId: item.wineId,
                caseSize: item.caseSizeId ? item.caseSizeId : item.caseSizeIds,
                languageId: this.$i18n.locale
            });
            this.$store.dispatch(AWines.GET_WINE_DETAILS);
            this.$router.push({path: (isBuy ? '/wine-trading-buy/' : '/wine-trading-sell/') + item.wineId});
        },
        checkWineSell(wineObj) {
            let isSellAvailable = true;
            this.portfolioSummary.forEach(wine => {
                if (wine.wineId === wineObj.wineId && wine.caseSizeId === (wineObj.caseSizeId ? wineObj.caseSizeId : parseInt(wineObj.caseSizeIds))) {
                    isSellAvailable = false;
                    return false;
                }
            });
            return isSellAvailable
        },
        toggleFav(event, wine) {
            event.stopPropagation();
            let currWineId = wine.wineId;
            let currWineCaseSizeId = wine.caseSizeId;
            this.$store.dispatch(AWines.SWITCH_WINE_FAVOURITE, {wineId: wine}).then(x => {
                this.$store.dispatch(AWines.GET_FAVOURITE_WINES).then(
                    this.filteredItems.forEach(wine => {
                        if (wine.wineId === currWineId) {
                            let isWineInFavourites = false;
                            this.favWinesList.forEach(wine => {
                                if (currWineId === wine.wineId && currWineCaseSizeId === wine.caseSizeId) {
                                    isWineInFavourites = true;
                                }
                            });
                            wine.isFavourite = isWineInFavourites;
                            return true
                        }
                    })
                )
            });
        },
        getImgUrl(imgUrl) {
            return "background-image: url('" + imgUrl + "')"
        },
        showSaturnalia() {
            this.saturnaliaMapDialog = true;

            if (this.isLogged) {
                if (typeof this.wineInfo.wine !== 'undefined' && this.wineInfo.wineGrapes) {this.iframeUrl = '/map.html?lwin=' + this.wineInfo.wineGrapes.lwin + '&vintage=' + this.wineInfo.wine.vintage;
                } else {
                    this.$store.dispatch(AWines.SELECT_WINE_ID, {
                        wineId: this.wineId,
                        caseSize: this.caseSizeId,
                        languageId: this.$i18n.locale
                    }).then(() => {
                        this.$store.dispatch(AWines.GET_WINE_DETAILS).then(() => {this.iframeUrl = '/map.html?lwin=' + this.wineInfo.wineGrapes.lwin + '&vintage=' + this.wineInfo.wine.vintage;

                            let filtersObj = {
                                vintage: null,
                                countryId: null,
                                regionId: null,
                                appellationId: null,
                                producerId: null,
                                colorId: null,
                                priceFrom: null,
                                priceTo: null,
                                isEnPrimeur: ''
                            };

                            this.$store.dispatch(AMarket.GET_WINES, filtersObj);
                        })
                    });
                }
            } else {
                if (this.wineInfo.wineGrapes) {
                    this.iframeUrl = '/map.html?lwin=' + this.wineInfo.wineGrapes.lwin + '&vintage=' + this.wineInfo.vintage;
                }
            }
        }
    },
    mounted() {
        this.windowHref = window.location.href;

        this.$store.dispatch(AUser.GET_USER_DATA).then(() => {
            this.isLogged = true;
            this.$store.dispatch(APortfolio.GET_PORTFOLIO_SUMMARY);
            this.$store.dispatch(AWines.SELECT_WINE_ID, {
                wineId: this.$nuxt._route.params.wineId,
                caseSize: typeof this.$nuxt._route.params.caseSizeId === 'undefined' ? 18 : this.$nuxt._route.params.caseSizeId,
                languageId: this.$i18n.locale
            });
            this.$store.dispatch(AWines.GET_WINE_DETAILS).then(() => {
                this.desc = this.wineInfo.wine.shortDescription
            });
        }).catch((err) => {
            this.isLogged = false;
            this.$store.dispatch(AWines.GET_WINE_DETAILS_NOT_LOGGED, {
                wineId: this.$nuxt._route.params.wineId,
                caseSize: '',
                languageId: this.$i18n.locale
            }).then(() => {
                this.desc = this.wineInfo.wineShortDescription
            })
        });
    }
}
</script>

<style scoped>
.info-text {
    background: #303030;
    border-radius: 6px;
    padding: 6px;
    color: #ffffff;
    text-align: center;
    width: 160px;
    font-size: 14px;
    position: absolute;
    right: -45px;
    height: 32px;
    margin-top: -59px;
    white-space: pre-line;
    display: none;
}
.info-text:before {
    content: "";
    position: absolute;
    top: 100%;
    right: 75px;
    width: 0;
    height: 0;
    border-left: 7px solid transparent;
    border-top: 10px solid #303030;
    border-right: 7px solid transparent;
}
.enprimeur:hover {
    cursor: pointer;
}
.enprimeur:hover .info-text {
    display: block;
}
.wine-details-head {
    display: flex;
}

.wine-details-head .left-col {
    flex-basis: 75%;
}

.wine-details-head .left-col .addition-description {
    font-family: Roboto, sans-serif;
    font-weight: normal;
    font-size: 18px;
    margin-top: 6px;
}

.wine-details-head .right-col {
    flex: 1;
}

.maturity {
    position: relative;
    top: -20px;
}

.maturity label {
    font-weight: 500;
    color: #8E8E93;
}

.wine-image2 {
    width: 18px;
    height: 12px;
    margin-right: 10px;
}

.wine-image2:hover {
    cursor: pointer;
}

.wine-image3 {
    margin-left: 15px;
}

.lang-item {
    display: inline-block;
}

.saturnalia-btn {
    border: 1px solid #CCCCCC;
    box-sizing: border-box;
    border-radius: 4px;
    width: 265px;
    height: 32px;
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 150%;
    text-align: center;
    color: #303030;
    padding: 4px;
    margin-top: 24px;
    margin-bottom: 24px;
}

.saturnalia-title {
    font-family: Montserrat, sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 25px;
    line-height: 120%;
    text-align: center;
    color: #303030;
    margin-bottom: 40px;
}

.saturnalia-btn:hover {
    background: #f6f6f6;
    cursor: pointer;
}

.saturnalia-map-wrapper {
    background: #f6f6f6;
    padding: 24px;
}

.sat-iframe {
    width: 100%;
    min-height: 472px;
}

.grapes-wrapper {
    background: #f6f6f6;
    height: 113px;
    padding: 24px 8px;
    margin-bottom: 24px;
    white-space: nowrap;
}

.grape-item {
    border-right: 1px solid #CCCCCC;
    display: inline-block;
    height: 100%;
    padding: 0 16px;
    text-align: center;
    min-width: 25%;
}

.grape-percent {
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 19px;
    line-height: 120%;
    color: #303030;
    margin-bottom: 8px;
}

.grape-percent-span {
    color: #B2B2B2;
}

.grape-title {
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 120%;
    text-align: center;
    color: #000000;
}

.enprimeur {
    background: #CEA94B;
    text-align: center;
    width: 84px;
    height: 25px;
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 17px;
    color: #FFFFFF;
    padding: 4px;
    margin-right: 20px;
    border-radius: 2px;
    position: relative;
}

.share-row {
}

.share-title {
    color: #b2b2b2;
    font-size: 14px;
    line-height: 23px;
    font-weight: normal;
}

.mobile-wines-header {
    display: flex;
    flex-wrap: wrap;
}

.mobile-wines-header div {
    color: #b2b2b2 !important;
    font-size: var(--fs-medium);
    font-weight: 300;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    height: 30px;
    white-space: nowrap;
    display: inline-block;
    flex-basis: 50%;
}

.mobile-wines-row {
    padding: 15px;
    display: flex;
    flex-wrap: wrap;
}

.mobile-wines-row:nth-child(odd) {
    background: #f5f5f5;
}

.mobile-wines-div {
    display: inline-block;
    flex-basis: 50%;
    vertical-align: top;
    height: 32px;
    line-height: 32px;
}

.mobile-line {
    line-height: 20px;
}

.sat-container {
    width: 100%;
}

.sat-container iframe {
    width: 100%;
    min-height: 500px;
}

.trading-desk-container.wine-details {
    height: calc(100% - 456px);
    padding: 80px calc(3 * var(--gutter)) calc(1.2 * var(--gutter));
}

.not-logged-h5 {
    margin-top: 40px;
}

.head-country-el {
    display: flex;
    align-items: center;
}

.head-country-el > div {
    line-height: 0;
}

.head-region-el {
    margin-left: 19px;
}

.my-investments-h5 {
    margin-top: 32px;
}

h5 {
    color: #707070;
}

.wine-info-wrapper {
    position: relative;
}

.collections-container {
    height: 100%;
}

h1 {
    color: var(--brand);
}

.collections-wrapper {
    padding: 0;
    height: 100%;
}

.wine-details-container {
    display: flex;
}

.wine-details-title {
    background: #024E7B;
    font-weight: 900;
    font-size: 80px;
    height: 100px;
}

.wine-details-title span {
    color: #FFFFFF;
    opacity: 0.1;
    text-transform: uppercase;
    position: relative;
    top: 12px;
    left: 30px;
}

.first-row {
    font-size: 25px;
    font-weight: bold;
    line-height: 30px;
}

.first-row .positive {
    color: green;
}

.second-row {
    font-size: var(--fs-base);
    line-height: 20px;
    color: #555555;
    font-weight: 300;
    margin-top: 10px;
}

.third-row {
    margin-bottom: 20px;
    margin-top: 5px;
}

.description-title {
    font-size: 16px;
    margin: 20px 0 10px;
}

.wine-details-info {
    width: calc(100% - 485px);
    padding: 55px 75px 55px 0;
    margin-right: 0;
}

.wine-details-trade {
    width: 350px;
    padding: 30px 30px 0 0;
    float: right;
}

.last-trade-el-class {
    margin: 0 15px;
}

.last-trade-el.right-side {
    margin-left: 1%;
}

.order-ticket {
    max-width: 320px;
    margin: 0 auto;
    border-radius: 5px;
    -webkit-box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.75);
    -moz-box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.75);
    box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.75);
}

.order-ticket.fixed {
    position: fixed;
    top: 90px;
}

.v-tab.v-tab {
    width: 50%;
    color: #024e7b;
    font-size: 16px;
    text-transform: uppercase;
}

.winemarket-winecolor-img {
    display: inline-block;
    width: 20px;
    height: 16px;
    position: relative;
    margin: 0 0 0 19px;
    background: url('../../../../assets/rose.png') no-repeat center;
    background-size: contain;
}

.winemarket-winecolor-img.redwine {
    background: url('../../../../assets/red.png') no-repeat center;
    background-size: contain;
}

.winemarket-winecolor-img.whitewine {
    background: url('../../../../assets/white.png') no-repeat center;
    background-size: contain;
}

.wine-details .no-orders-info {
    background: #ffffff !important;
    color: #000000;
    text-align: center;
    font-size: 20px;
    font-weight: 300;
    font-family: 'Roboto', sans-serif;
    line-height: 200px;
}

.wine-details-wine {
    font-weight: 400;
    font-size: 30px;
    padding: 0 15px;
    height: 35px;
}

.wine-details-trade-value {
    padding: 0 15px;
    height: 35px;
    font-weight: 700;
    font-size: 40px;
    color: #024E7B;
}

.wine-details-trade-title,
.wine-details-region {
    font-size: 14px;
    color: #000;
}

.wine-details-region {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
}

.wine-details-trade-title {
    position: relative;
    top: 4px;
}

.wine-details-img {
    width: 30px;
    height: 19px;
    border: 1px solid #DEE2E4;
    position: relative;
    margin-right: 10px;
}

.wine-details-wine-size {
    font-size: 20px;
    font-weight: 300;
}

.wine-details-trade-profit {
    font-size: 20px;
}

.wine-details-trade-profit.positive,
.portfolio-profit.positive {
    color: green;
}

.wine-details-trade-profit.negative,
.portfolio-profit.negative {
    color: red;
}

.footer-logo {
    margin-top: 50px;
}

.footer-logo-text {
    font-size: 14px;
    color: #D1D1D0;
}

.investments-table {
    border: 1px solid #e6e6e6;
    height: 246px;
}

.investments-table tbody tr {
    border-bottom: 1px solid rgba(0, 0, 0, .12);
}

.investments-table tbody tr td {
    font-size: 18px;
}

.investments-table tbody tr td.portfolio-details {
    text-align: center;
}

.details-img {
    position: relative;
    top: 3px;
    margin-right: 5px;
}

.back-order {
    font-size: 16px;
    font-weight: 300;
    color: #b2b2b2;
    margin-left: auto;
}

.back-order svg {
    fill: #b2b2b2;
    margin-left: 5px;
}

.back-order:hover {
    color: var(--brand);
    cursor: pointer;
}

.back-order:hover svg {
    fill: var(--brand);
}

.order-ticket .v-tabs-slider {
    background-color: #024E7B;
}

.wine-details .wine-image {
    background: url('../../../../assets/collections/wines/wine1.png') no-repeat center;
    position: absolute;
    top: 115px;
    width: 485px;
    height: 580px;
    background-size: contain;
}

.wine-details.trading-desk-container h2 {
    font-size: 39px;
    line-height: 120%;
    margin: 0;
}

.wine-details.trading-desk-container .producer {
    display: flex;
}

.wine-details .second-row {
    margin-right: 0;
    margin-left: 0;
}

.wine-details .wine-details-shortdesc {
    margin-top: 25px;
    margin-bottom: 35px;
    color: #8E8E93;
    font-weight: 300;
}

.wine-details .rating-logo1 {
    background: url('../../../../assets/wine_advocate.png') no-repeat left;
    width: 100px;
    height: 32px;
    margin: 0 auto;
    background-size: contain;
}

.wine-details .rating-logo2 {
    background: url('../../../../assets/james_suckling.png') no-repeat left;
    width: 100px;
    height: 32px;
    margin: 0 auto;
    background-size: contain;
}

.wine-details .rating-logo3 {
    background: url('../../../../assets/wine_spectator.png') no-repeat left;
    width: 100px;
    height: 32px;
    margin: 0 auto;
    background-size: contain;
}

.wine-details .rating-logo4 {
    background: url('../../../../assets/jancis_robinson.png') no-repeat left;
    width: 100px;
    height: 32px;
    margin: 0 auto;
    background-size: contain;
}

.wine-details .rating-logo5 {
    background: url('../../../../assets/antonio_galloni.png') no-repeat left;
    width: 100px;
    height: 32px;
    margin: 0 auto;
    background-size: contain;
}

.wine-details .rating-item {
    margin: 0;
    width: 185px;
    height: 80px;
    border-right: 1px solid #CACBCA;
    text-align: center;
    padding-top: 10px;
    font-weight: 300;
}

.wine-details .rating-item:first-of-type {
    padding-left: 0;
}

.wine-details .rating-title {
    font-size: var(--fs-base);
    font-weight: 300;
    margin: 0;
    color: #B3B4B3;
    margin-bottom: 12px;
}

.wine-details .rating-value {
    color: #272727;
    margin-bottom: 10px;
    font-size: 24px;
}

.wine-details .rating-value span {
    font-size: 24px;
    color: #B3B4B3;
}

.wine-details .offers-item .offers-label {
    font-size: 16px;
    margin: 0;
    color: #505050;
    margin-bottom: 10px;
}

.winemarket-change {
    color: #b2b2b2;
    font-size: var(--fs-small);
    margin: 2px 0;
}

.winemarket-change.negative div {
    width: 10px;
    height: 15px;
    background-size: contain;
    display: inline-block;
    top: 1px;
    position: relative;
    background: url('../../../../assets/price-low-10px.svg') no-repeat center;
}

.winemarket-change.positive div {
    width: 10px;
    height: 15px;
    background-size: contain;
    display: inline-block;
    top: 1px;
    position: relative;
    background: url('../../../../assets/price-up-10px.svg') no-repeat center;
}

.market-btn-col {
    width: 100px;
}

.market-btn-col2 {
    width: 125px;
}

.market-btn-col22 {
    margin-right: 19px;
}

.half-padding-left {
    padding-left: calc(0.5 * var(--gutter));
}

.no-padding-right {
    padding-right: 24px;
}

.half-padding-right {
    padding-right: calc(0.5 * var(--gutter));
}

.market-btn {
    width: 125px;
    font-weight: 300;
    text-align: center;
    line-height: 1em;
    height: 32px;
}

.bids-offers-modal h3 {
    margin-bottom: 16px;
    font-size: var(--fs-large);
}

.btn-bid-proceed {
    font-size: var(--fs-base);
    text-transform: initial;
    font-weight: 300;
    padding: 0 20px !important;
    background: var(--brand);
    color: #ffffff;
}

.btn-login {
    background: #004f7f;
    border-color: #004f7f;
}

.btn-bid-cancel {
    font-size: var(--fs-base);
    text-transform: initial;
    font-weight: 300;
    padding: 0 20px !important;
}

.btn-bid-cancel:hover {
    color: #ffffff;
}

.bids-offers-modal {
    padding: 32px 48px;
    text-align: center;
    background: #f6f6f6;
}

.saturnalia-modal {
    background: #ffffff;
    padding: 31px 0 64px;
}

.bids-offers-modal .warning-icon {
    background: url('../../../../assets/report_problem-24px.svg') no-repeat center;
    background-size: contain;
    width: 40px;
    height: 40px;
    margin: 0 auto;
}

.bids-title svg {
    margin-right: 5px;
    fill: #707070;
}

.offers-title svg {
    margin-right: 5px;
    fill: #707070;
}

.cancel-bid-body {
    text-align: center;
    justify-content: center;
    font-size: var(--fs-base);
}

@media (min-width: 1025px) and (max-width: 1601px) {
    .wine-details .wine-image {
        width: 250px;
        height: 400px;
    }

    .wine-details-info {
        width: calc(100% - 250px);
        padding-right: 0;
    }
}

@media all and (max-width: 1024px) {
    .collections-container {
        width: 100%;
    }

    .collections-wrapper {
        display: flex;
        flex-direction: column;
    }

    .wine-details .wine-image {
        position: static;
        top: 0;
        margin: 20px auto 30px;
        max-height: 100%;
        width: 100%;
        height: 300px;
    }

    .wine-details-container .wine-details-info {
        width: 100%;
        padding: 0;
        margin-right: 0;
    }

    .wine-details-head .left-col {
        flex: 1;
    }

    .wine-details-head .right-col.producer {
        display: none;
    }

    .wine-details-region {
        margin-left: 0;
    }

    .wine-details-head .enprimeur {
        font-size: 13px;
        margin: 0 20px 0 0;
    }

    .wine-details-head .last-trade-el.right-side {
        margin-left: 0;
    }
}

@media (max-width: 767px) {
    .wine-details-head {
        flex-direction: column;
    }

    .wine-details-head .back-order {
        margin: 0;
    }

    .wine-details-head .left-col {
        order: 1;
        flex-basis: 100%;
    }

    .wine-details-head .right-col {
        order: 2;
    }

    .wine-details-region {
        font-size: 14px;
    }

    .btn-bid-proceed {
        padding: 0 5px !important;
    }

    .mobile-wines-div.market-btn-col {
        width: 100%;
    }

    .mobile-wines-div.market-btn-col .market-btn {
        width: 100%;
    }

    .trading-desk-container.wine-details {
        padding-left: 15px;
        padding-right: 15px;
    }

    .wine-details .wine-image {
        position: relative;
        top: 15px;
        width: 100%;
        height: 300px;
        background-size: contain;
        margin-bottom: 30px;
    }

    .wine-details-container {
        display: block;
    }

    .wine-details-info {
        width: 100%;
        padding: 0;
    }

    .wine-details .rating-item {
        width: 50%;
        display: inline-block;
        border-right: 0;
        margin-bottom: 30px;
    }

    .layout {
        display: block;
    }

    .wine-details.trading-desk-container h2 {
        font-size: 20px;
        line-height: 22px;
    }

    .winemarket-winecolor-img {
        margin-left: 0;
    }

    .wine-details .offers {
        height: auto;
    }

    .wine-details .offers-item {
        display: block;
        width: 100%;
        max-width: 100%;
    }

    .wine-details .offers > .row {
        display: block;
    }

    .wine-details .offers-item div {
        display: inline-block;
        width: 50%;
        height: 40px;
        line-height: 40px;
    }

    .wine-details .offers-item div.winemarket-change {
        display: none;
    }

    .wine-details .offers-item div.market-btn-col22 {
        width: calc((100% - 38px) / 2);
    }

    .wine-details .offers-item .market-btn.market-btn-sell {
        margin-right: 0;
    }

    .wine-details .offers-item div.market-btn {
        width: 100%;
    }

    .wine-details .offers-item.btn-wrapper {
        height: 40px;
    }

    .trading-desk-container.wine-details {
        height: calc(100% - 1300px);
    }

    .wine-details .investments-item.medium-bottles,
    .wine-details .investments-item.gain,
    .wine-details .investments-item.bottles {
        width: 100%;
        text-align: left;
        border-right: 0;
    }

    .wine-details .my-investments {
        display: block;
        height: auto;
        margin-bottom: 0;
    }

    .wine-details .my-investments .investments-label,
    .wine-details .my-investments .bold {
        display: inline-block;
        width: 50%;
    }

    .wine-details .my-investments .bold {
        text-align: right;
    }

    .wine-details-img {
        top: 0;
        height: 17px;
    }

    .head-region-el {
        margin-left: 0;
    }

    .share-row-mobile {
        margin-top: 20px;
    }

    .share-title {
        display: inline-block;
        margin-right: 15px;
        vertical-align: top;
    }
}
</style>

<style>
.bids-offers-modal .v-card__title,
.bids-offers-modal .v-card__actions {
    justify-content: center;
}

.wine-details .offers {
    width: 100%;
    height: 130px;
    border-radius: 10px;
    background-color: #F5F6F5;
    padding: 20px 24px;
    margin: 35px 0;
}

.wine-details .offers > .row {
    align-items: flex-start;
}

.wine-details .offers-item {
    padding: 0;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
}

.wine-details .offers-item.btn-wrapper {
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    height: 90px;
}

.wine-details .offers-item .market-btn {
    width: 132px;
    background: #fff;
    border: 1px solid #AFB0AF;
    text-align: center;
    padding: 0;
    line-height: 32px;
    height: 32px;
}

.wine-details .offers-item .market-btn.market-btn-sell {
    margin-right: 32px;
}

.wine-details .offers-item.btn-wrapper .market-btn:hover {
    background: #E2C477;
    border-color: #E2C477;
    cursor: pointer;
}

.wine-details .offers-item .bold {
    font-weight: bold;
    font-size: 20px;
    line-height: 20px;
}

.winemarket-table {
    background-color: transparent;
    box-shadow: none !important;
}

.wine-star {
    background: url('../../../../assets/star-not-selected.svg') no-repeat center;
    width: 33px;
    height: 33px;
    display: block;
    background-size: contain;
}

.wine-star:focus,
.wine-star:active {
    outline: none;
}

.wine-star.active,
.wine-star:hover {
    background: url('../../../../assets/star-selected.svg') no-repeat center;
    background-size: contain;
}

.wine-star.active:hover {
    opacity: 0.8;
}

.wine-details .my-investments {
    width: 100%;
    height: 135px;
    border-radius: 0;
    background-color: #E1C376;
    padding: 25px 50px;
    margin: 15px 0 30px 0;
    display: flex;
}

.wine-details .my-investments .investments-item {
    text-align: right;
    border-right: 1px solid #FADF95;
    padding-right: 15px;
}

.wine-details .investments-item.bottles {
    width: 10%;
}

.wine-details .investments-item.medium-bottles {
    width: 35%;
}

.wine-details .investments-item.gain {
    width: 20%;
}

.wine-details .my-investments .investments-label {
    color: #FBEAC0;
    margin-bottom: 15px;
}

.wine-details .my-investments .bold {
    color: #fff;
    font-weight: bold;
    font-size: 24px;
}

.wine-details .theme--light.v-data-table.winemarket-table.investment-table tbody tr td {
    width: 70px;
}

.wine-details .theme--light.v-data-table.winemarket-table.investment-table tbody tr td .dots {
    display: inline-block;
    width: 8px;
    height: 18px;
    position: relative;
    margin: 0;
    background: url('../../../../assets/dots-only-for-example.png') no-repeat center;
    background-size: contain;
    cursor: pointer;
}

.wine-details .theme--light.v-data-table.winemarket-table.investment-table thead tr th.gain-th:after {
    content: '';
    width: 15px;
    height: 15px;
    background: url('../../../../assets/info-icon-for-example.png') no-repeat center;
    position: absolute;
    right: -15px;
    top: 15px;
    background-size: cover;
}

.v-data-table td.winedetails-winesize-td {
    padding-left: 0;
}

.theme--light.v-data-table.v-data-table--fixed-header.winemarket-table thead th.wine-th {
    padding-left: 0;
}

.theme--light.v-data-table.v-data-table--fixed-header.winemarket-table.winemarket-table-details thead th:hover {
    color: #b2b2b2 !important;
}

.share-network-facebook,
.share-network-twitter,
.share-network-linkedin,
.share-network-viber,
.share-network-email,
.share-network-whatsapp {
    display: inline-block;
    margin-left: 11px;
}

.share-network-email svg {
    width: 18px;
    height: 18px;
    position: relative;
    top: 2px;
}

.share-network-facebook:hover svg,
.share-network-facebook:hover path {
    fill: #3b5998;
    cursor: pointer;
}

.share-network-twitter:hover svg,
.share-network-twitter:hover path {
    fill: #00acee;
    cursor: pointer;
}

.share-network-linkedin:hover svg,
.share-network-linkedin:hover path {
    fill: #0e76a8;
    cursor: pointer;
}

.share-network-viber:hover svg,
.share-network-viber:hover path,
.share-network-email:hover svg {
    fill: #7360f2;
    cursor: pointer;
}

.share-network-whatsapp:hover svg,
.share-network-whatsapp:hover path {
    fill: #25D366;
    cursor: pointer;
}
</style>
